import { r as react, R as React, _ as __rest, b as __awaiter } from './FronteggApp-069cf29e.js';
import { p as propTypes, i as isobject, h as has, a as propertyExpr, m as mapValues, c as clone, b as createStyled, B as Box, s as styled$3, C as Card, A as Alert$1, d as Button$1$1, u as useShadowDom, S as SuccessIcon, e as useFormikContext, I as Input$1, R as RenderAsSlot, L as Link, T as Typography, f as themeSelector, g as ShadowDomContext, j as enhanceTheme, k as initGlobalTheme, l as I18nProvider$1, G as GlobalThemeProvider, n as ThemeContext, o as InnerThemeProvider, q as useTheme, r as useAuth, v as useAuthRoutes, P as Provider, F as FronteggStoreContext, w as useTranslation, x as Loader$1, y as useOnRedirectTo, z as useSocialLoginState, D as useSocialLoginActions, E as useSSOState, H as useSSOActions, J as useLoginActions, K as useAuthActions, M as useIsAuthenticated, N as useAuthUserOrNull, O as DynamicComponent, Q as useAcceptInvitationActions, U as useAcceptInvitationState, V as useActivateAccountState, W as useForgotPasswordState, X as useForgotPasswordActions, Y as useSignUpState, Z as useLoginState, _ as useSecurityPolicyState, $ as useSecurityPolicyActions, a0 as Grid, a1 as validateSchema, a2 as validatePasswordUsingOWASP, a3 as validateConfirmPassword, a4 as validateEmail$1, a5 as Owasp, a6 as useSignUpActions, a7 as validateMinLength, a8 as useVendorState, a9 as SvgIcon, aa as Formik, ab as Form, ac as Collapse$1, ad as useMfaState, ae as useMfaActions, af as validateTwoFactorCode, ag as useField, ah as InputPassword$1, ai as PasswordStrengthChecker, aj as Checkbox, ak as callbackToPromise, al as InputCopy$1 } from './Link-978e3220.js';
import { ContextHolder, fetch, AuthStrategyEnum as AuthStrategyEnum$1, SocialLoginProviders } from '@frontegg/rest-api';
import { LoginStep, AcceptInvitationStep, ActivateAccountStep, ForgotPasswordStep, AuthStrategyEnum, MFAStep as MFAStep$1 } from '@frontegg/redux-store';
import '@frontegg/types';
import './utils.js';
import './AppHolder.js';

var dist=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=2)}([function(e,t){e.exports=react.exports;},function(e,t){e.exports=propTypes.exports;},function(e,t,n){n.r(t),n.d(t,"ReCaptcha",(function(){return v})),n.d(t,"loadReCaptcha",(function(){return h}));var r=n(0),o=n.n(r);n(1);function a(e){return (a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function u(e,t){return (u=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function i(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return !1}}();return function(){var n,r=p(e);if(t){var o=p(this).constructor;n=Reflect.construct(r,arguments,o);}else n=r.apply(this,arguments);return f(this,n)}}function f(e,t){return !t||"object"!==a(t)&&"function"!=typeof t?l(e):t}function l(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e){return (p=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function s(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var d,y=function(){return "undefined"!=typeof window&&void 0!==window.grecaptcha&&void 0!==window.grecaptcha.execute},b=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&u(e,t);}(f,e);var t,n,a=i(f);function f(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,f),s(l(t=a.call(this,e)),"execute",(function(){var e=t.props,n=e.sitekey,r=e.verifyCallback,o=e.action;t.state.ready&&window.grecaptcha.execute(n,{action:o}).then((function(e){void 0!==r&&r(e);}));})),s(l(t),"_updateReadyState",(function(){y()&&(t.setState((function(){return {ready:!0}})),clearInterval(d));})),t.state={ready:y()},t}return t=f,(n=[{key:"componentDidMount",value:function(){this.state.ready?this.execute():d=setInterval(this._updateReadyState,1e3);}},{key:"componentDidUpdate",value:function(e,t){this.state.ready&&!t.ready&&this.execute();}},{key:"componentWillUnmount",value:function(){clearInterval(d);}},{key:"render",value:function(){return this.state.ready?o.a.createElement("div",{id:this.props.elementID,"data-verifycallbackname":this.props.verifyCallbackName}):o.a.createElement("div",{id:this.props.elementID,className:"g-recaptcha"})}}])&&c(t.prototype,n),f}(r.Component);b.defaultProps={elementID:"g-recaptcha",verifyCallbackName:"verifyCallback"};var v=b,h=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){},n=document.createElement("script");!window.onLoadCaptchaV3Callback&&t&&(window.onLoadCaptchaV3Callback=t),n.src="https://www.recaptcha.net/recaptcha/api.js?onload=onLoadCaptchaV3Callback&render=".concat(e),document.body.appendChild(n);};}]);

/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */

const isObject = isobject;

var getValue = function(target, path, options) {
  if (!isObject(options)) {
    options = { default: options };
  }

  if (!isValidObject(target)) {
    return typeof options.default !== 'undefined' ? options.default : target;
  }

  if (typeof path === 'number') {
    path = String(path);
  }

  const isArray = Array.isArray(path);
  const isString = typeof path === 'string';
  const splitChar = options.separator || '.';
  const joinChar = options.joinChar || (typeof splitChar === 'string' ? splitChar : '.');

  if (!isString && !isArray) {
    return target;
  }

  if (isString && path in target) {
    return isValid(path, target, options) ? target[path] : options.default;
  }

  let segs = isArray ? path : split(path, splitChar, options);
  let len = segs.length;
  let idx = 0;

  do {
    let prop = segs[idx];
    if (typeof prop === 'number') {
      prop = String(prop);
    }

    while (prop && prop.slice(-1) === '\\') {
      prop = join([prop.slice(0, -1), segs[++idx] || ''], joinChar, options);
    }

    if (prop in target) {
      if (!isValid(prop, target, options)) {
        return options.default;
      }

      target = target[prop];
    } else {
      let hasProp = false;
      let n = idx + 1;

      while (n < len) {
        prop = join([prop, segs[n++]], joinChar, options);

        if ((hasProp = prop in target)) {
          if (!isValid(prop, target, options)) {
            return options.default;
          }

          target = target[prop];
          idx = n - 1;
          break;
        }
      }

      if (!hasProp) {
        return options.default;
      }
    }
  } while (++idx < len && isValidObject(target));

  if (idx === len) {
    return target;
  }

  return options.default;
};

function join(segs, joinChar, options) {
  if (typeof options.join === 'function') {
    return options.join(segs);
  }
  return segs[0] + joinChar + segs[1];
}

function split(path, splitChar, options) {
  if (typeof options.split === 'function') {
    return options.split(path);
  }
  return path.split(splitChar);
}

function isValid(key, target, options) {
  if (typeof options.isValid === 'function') {
    return options.isValid(key, target);
  }
  return true;
}

function isValidObject(val) {
  return isObject(val) || Array.isArray(val) || typeof val === 'function';
}

var getValue$1 = getValue;

const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must be have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

var isSchema = (obj => obj && obj.__isYupSchema__);

class Condition {
  constructor(refs, options) {
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

var Condition$1 = Condition;

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$2({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues(_extends$1({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = _extends$1({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        });
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  has(value, resolve) {
    if (this.list.has(value)) return true;
    let item,
        values = this.refs.values();

    while (item = values.next(), !item.done) if (resolve(item.value) === value) return true;

    return false;
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.conditions = [];
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      label: undefined,
      meta: undefined,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(_extends({}, this.spec, spec));
    return next;
  }

  label(label) {
    var next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = _extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, _extends({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    if (this._whitelistError) initialTests.push(this._whitelistError);
    if (this._blacklistError) initialTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests,
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(_extends({}, options, {
      value
    }));
    let result;

    schema._validate(value, _extends({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    var next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    var next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    var next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition$1(deps, options));
    return next;
  }

  typeError(message) {
    var next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    var next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    var next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

}
// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

var isAbsent = (value => value == null);

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }

}
create.prototype = StringSchema.prototype; //
// String Interfaces
//

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

const redirectIfFronteggPath = (_routes, basename, urlStrategy, path, opts) => {
    const routes = __rest(_routes, ["authenticatedUrl", "signUpSuccessUrl"]);
    if (path === '/') {
        return false;
    }
    const fronteggPath = Object.values(routes).find((p) => p.startsWith(path));
    if (!fronteggPath) {
        return false;
    }
    const calculatedBasename = basename ? (basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '') : '';
    let newPath = calculatedBasename + path;
    if (opts === null || opts === void 0 ? void 0 : opts.preserveQueryParams) {
        newPath += window.location.search;
    }
    if (urlStrategy === 'path') {
        window.history.pushState(null, '', newPath);
    }
    else {
        window.history.pushState(null, '', `#${newPath}`);
    }
    return true;
};
const StoreListener = () => {
    var _a;
    const timer = react.exports.useRef(0);
    const { builderMode, contextOptions, basename, urlStrategy, onRedirectTo: onRedirectToProp, hostedLoginBox } = useShadowDom();
    const routes = useAuthRoutes();
    const { setState: setAuthState, logout } = useAuthActions();
    const isAuthenticated = useIsAuthenticated();
    const { keepSessionAlive } = useAuth(({ keepSessionAlive }) => ({ keepSessionAlive }));
    const user = useAuthUserOrNull();
    const { requestAuthorize } = useLoginActions();
    const updateSessionTimer = react.exports.useCallback(() => {
        timer.current && clearInterval(timer.current);
        if (isAuthenticated && !hostedLoginBox) {
            if (keepSessionAlive === true) {
                const ttl = ((user === null || user === void 0 ? void 0 : user.expiresIn) || 20) * 1000 * 0.8;
                timer.current = setInterval(() => requestAuthorize(), ttl);
            }
            else {
                const ttl = ((user === null || user === void 0 ? void 0 : user.expiresIn) || 20) * 1000;
                timer.current = setInterval(() => logout(), ttl);
            }
        }
    }, [keepSessionAlive, isAuthenticated, logout, requestAuthorize, user === null || user === void 0 ? void 0 : user.expiresIn]);
    ContextHolder.setAccessToken((_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '');
    ContextHolder.setUser(user);
    ContextHolder.setContext(contextOptions);
    const onRedirectTo = react.exports.useCallback((path, opts) => {
        document.dispatchEvent(new CustomEvent('frontegg_onRedirectTo_fired'));
        if (redirectIfFronteggPath(routes, basename, urlStrategy, path, opts)) {
            return;
        }
        else if (onRedirectToProp && !path.startsWith('http')) {
            onRedirectToProp(path, opts);
        }
        else {
            if (opts === null || opts === void 0 ? void 0 : opts.preserveQueryParams) {
                path = `${path}${window.location.search}`;
            }
            if (urlStrategy === 'path' || path.startsWith('http')) {
                window.location.href = path;
            }
            else {
                window.location.href = `${window.location.pathname}#${path}`;
            }
        }
    }, [basename, urlStrategy, routes, onRedirectToProp]);
    react.exports.useEffect(() => {
        setAuthState({ onRedirectTo });
        ContextHolder.setOnRedirectTo(onRedirectTo);
    }, [onRedirectTo, setAuthState]);
    react.exports.useEffect(() => {
        if (hostedLoginBox) {
            setAuthState({ isLoading: false });
        }
        else if (!builderMode) {
            requestAuthorize(true);
        }
    }, [requestAuthorize, builderMode, hostedLoginBox]);
    react.exports.useEffect(() => {
        updateSessionTimer();
    }, [updateSessionTimer, isAuthenticated]);
    return null;
};

const AppLayout = ({ children }) => {
    const { injector, customStyles } = useShadowDom();
    return React.createElement(Provider, { context: FronteggStoreContext, store: injector.store },
        React.createElement(StoreListener, null),
        customStyles && React.createElement("style", { type: 'text/css', dangerouslySetInnerHTML: { __html: customStyles } }),
        children);
};
const App = ({ children }) => {
    const { isShadowDom, } = useShadowDom();
    const { calculatedTheme, theme, overrides } = initGlobalTheme();
    return React.createElement(I18nProvider$1, null,
        React.createElement(GlobalThemeProvider, { theme: calculatedTheme, isShadowDom: isShadowDom },
            React.createElement(ThemeContext.Provider, { value: { theme, overrides } },
                React.createElement(InnerThemeProvider, { themeOptionKey: 'loginBox' },
                    React.createElement(AppLayout, null, children)))));
};

const styled$2 = createStyled();
const buildLayout = (theme) => {
    var _a, _b;
    const layoutType = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'center';
    if (layoutType !== 'center') {
        return {
            flexDirection: layoutType == 'float-left' ? 'row' : 'row-reverse',
            ['@media (max-width:1000px)']: {
                '& .fe-page-side-element': {
                    display: 'none',
                },
            },
        };
    }
    return {};
};
const RootElementContainer = styled$2(Box)(({ theme }) => (Object.assign(Object.assign(Object.assign({ position: 'fixed', display: 'flex', flexDirection: 'row', width: '100vw', height: '100vh', top: 0, left: 0 }, theme.rootStyle), { '& .fe-page-side-element': {
        flex: 1,
        height: '100vh',
        overflow: 'auto',
    } }), buildLayout(theme))));
const RootElement = ({ children, themeOptionKey }) => {
    return React.createElement(InnerThemeProvider, { themeOptionKey: themeOptionKey, withFallback: true },
        React.createElement(RootElementContainer, null, children));
};
var RootElement$1 = RootElement;

const useT = (root) => {
    const { t } = useTranslation();
    return react.exports.useCallback((key, options, defaultValue) => {
        return t(`loginBox.${root}.${key}`, options, defaultValue);
    }, [t]);
};
const useGlobalT = () => {
    const { t } = useTranslation();
    return react.exports.useCallback((key, options, defaultValue) => {
        return t(key, options, defaultValue);
    }, [t]);
};
const defaultPasswordConfig = {
    allowPassphrases: true,
    maxLength: 128,
    minLength: 6,
    minOptionalTestsToPass: 1,
    minPhraseLength: 6,
};
const IDENTITY_CONFIGURATION_SERVICE_URL_V1 = '/identity/resources/configurations/v1';
const usePasswordConfig = (userId) => {
    const { setForgotPasswordState, loadPasswordConfig } = useForgotPasswordActions();
    const { passwordConfig, loading } = useForgotPasswordState();
    const { builderMode } = useShadowDom();
    react.exports.useEffect(() => {
        if (loading) {
            return;
        }
        if (!passwordConfig) {
            if (userId || builderMode) {
                loadPasswordConfig({ userId: userId !== null && userId !== void 0 ? userId : 'demo-user' });
            }
            else {
                // TODO: to be replaced with loadPublicPasswordConfig
                fetch.Get(`${IDENTITY_CONFIGURATION_SERVICE_URL_V1}/password`).then((data) => __awaiter(void 0, void 0, void 0, function* () {
                    setForgotPasswordState({ loading: false, passwordConfig: data });
                })).catch(e => {
                    setForgotPasswordState({ loading: false, passwordConfig: defaultPasswordConfig });
                });
            }
        }
    }, [loading, passwordConfig, setForgotPasswordState, loadPasswordConfig]);
    const passwordServerConfig = Object.assign(Object.assign({}, defaultPasswordConfig), passwordConfig);
    const strength = passwordServerConfig.minLength <= 6 ? 'easy' : passwordServerConfig.minLength <= 8 ? 'medium' : 'hard';
    return {
        loading,
        passwordConfig: loading && !passwordConfig ? defaultPasswordConfig : passwordServerConfig,
        defaultPasswordConfig,
        strength,
    };
};
const useRecaptcha = ({ action, recaptchaRef }) => {
    var _a, _b, _c, _d;
    const { loadSecurityPolicyCaptcha } = useSecurityPolicyActions();
    const { captchaPolicy } = useSecurityPolicyState();
    const [token, setToken] = react.exports.useState('');
    const timer = react.exports.useRef(null);
    react.exports.useEffect(() => {
        !captchaPolicy.policy && loadSecurityPolicyCaptcha();
    }, [captchaPolicy.policy, loadSecurityPolicyCaptcha]);
    react.exports.useEffect(() => {
        var _a;
        if ((_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled)
            dist.loadReCaptcha(captchaPolicy.policy.siteKey || '');
    }, [(_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled, (_b = captchaPolicy.policy) === null || _b === void 0 ? void 0 : _b.siteKey]);
    const handleCallback = react.exports.useCallback((token) => {
        setToken(token);
        timer.current && clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            var _a;
            if ((_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled) {
                dist.loadReCaptcha(captchaPolicy.policy.siteKey || '');
            }
        }, 60 * 1000);
    }, [setToken, dist.loadReCaptcha, captchaPolicy]);
    // clear timeout on unmount
    react.exports.useCallback(() => () => timer.current && clearTimeout(timer.current), []);
    if (!((_c = captchaPolicy.policy) === null || _c === void 0 ? void 0 : _c.enabled))
        return null;
    return {
        token,
        component: React.createElement(dist.ReCaptcha, { sitekey: (_d = captchaPolicy.policy) === null || _d === void 0 ? void 0 : _d.siteKey, ref: recaptchaRef, verifyCallback: handleCallback, action: action }),
    };
};
const useVerifyInviteToken = () => {
    var _a;
    const url = new URL(window.location.href);
    const invitationToken = (_a = url.searchParams.get('invitationToken')) !== null && _a !== void 0 ? _a : '';
    const { verifyInviteToken } = useLoginActions();
    react.exports.useEffect(() => {
        invitationToken && verifyInviteToken({ token: invitationToken });
    }, [invitationToken, verifyInviteToken]);
    return { invitationToken };
};
const useQueryParams = (...keys) => {
    const params = new URLSearchParams(window.location.search);
    const result = {};
    keys.forEach((key) => {
        result[key] = params.get(key);
    });
    return result;
};

const UnstyledCustomComponent = (_a) => {
    var { componentKey, children, className } = _a, props = __rest(_a, ["componentKey", "children", "className"]);
    const theme = useTheme();
    const t = useGlobalT();
    const component = getValue$1(theme, componentKey);
    if (component === undefined) {
        if (!children) {
            return null;
        }
        return React.createElement("div", { className: className }, children);
    }
    if (component === null) {
        return null;
    }
    if (typeof component === 'function') {
        const html = component(Object.assign(Object.assign({}, props), { t, className }));
        if (react.exports.isValidElement(html)) {
            return React.cloneElement(html);
        }
        if (typeof html === 'string') {
            return React.createElement("div", { dangerouslySetInnerHTML: { __html: html } });
        }
        else {
            console.error('Unsupported custom element format, html must be a string');
            return null;
        }
    }
    if (typeof component === 'string') {
        return React.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: component } });
    }
    else {
        console.error('Unsupported custom element format, html must be a string');
        return null;
    }
};
const CustomComponent = styled$3(UnstyledCustomComponent)(({ theme, componentKey }) => (Object.assign({}, theme[`${componentKey}Style`])));

const Container$3 = styled$3(Box)({
    textAlign: 'center',
    color: '#a9a9ab',
    marginTop: '3rem',
    cursor: 'pointer',
    '> a': {
        color: 'currentColor',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover .frontegg-logo': {
            color: '#8f8f8f',
        }
    },
});
const PowerByFrontegg = (props) => {
    const { whiteLabelMode } = useVendorState(({ whiteLabelMode }) => ({ whiteLabelMode }));
    if (whiteLabelMode !== null && whiteLabelMode !== void 0 ? whiteLabelMode : false) {
        return null;
    }
    return React.createElement(Container$3, Object.assign({}, props),
        React.createElement("a", { href: 'https://frontegg.com', target: '_blank' },
            React.createElement(SvgIcon, { sx: { width: '165px' }, viewBox: "0 0 165 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M0.99778 10.6198H2.56428V7.35027H4.86528C4.95195 7.35027 5.06678 7.34593 5.20978 7.33727C5.35711 7.3286 5.49145 7.3156 5.61278 7.29827C6.41878 7.1726 7.01678 6.83677 7.40678 6.29077C7.80111 5.74043 7.99828 5.0796 7.99828 4.30827C7.99828 3.5326 7.80328 2.87177 7.41328 2.32577C7.02761 1.77543 6.42745 1.43743 5.61278 1.31177C5.49145 1.2901 5.35928 1.2771 5.21628 1.27277C5.07328 1.2641 4.95628 1.25977 4.86528 1.25977H0.99778V10.6198ZM2.56428 5.88777V2.72877H4.80028C4.88695 2.72877 4.98445 2.7331 5.09278 2.74177C5.20111 2.75043 5.30078 2.7656 5.39178 2.78727C5.65178 2.85227 5.85545 2.96927 6.00278 3.13827C6.15445 3.30293 6.26061 3.48927 6.32128 3.69727C6.38628 3.90527 6.41878 4.10893 6.41878 4.30827C6.41878 4.5076 6.38628 4.71127 6.32128 4.91927C6.26061 5.12727 6.15445 5.3136 6.00278 5.47827C5.85545 5.64293 5.65178 5.75777 5.39178 5.82277C5.30078 5.84877 5.20111 5.8661 5.09278 5.87477C4.98445 5.88343 4.88695 5.88777 4.80028 5.88777H2.56428Z", fill: "currentColor" }),
                React.createElement("path", { d: "M12.5468 10.8148C13.2488 10.8148 13.8619 10.6588 14.3863 10.3468C14.9106 10.0304 15.3179 9.59493 15.6083 9.04027C15.9029 8.48127 16.0503 7.83777 16.0503 7.10977C16.0503 6.3861 15.9051 5.74693 15.6148 5.19227C15.3244 4.63327 14.9171 4.1956 14.3928 3.87927C13.8684 3.56293 13.2531 3.40477 12.5468 3.40477C11.8578 3.40477 11.2511 3.56077 10.7268 3.87277C10.2024 4.18477 9.79292 4.6181 9.49826 5.17277C9.20359 5.72743 9.05626 6.3731 9.05626 7.10977C9.05626 7.83343 9.19926 8.47477 9.48526 9.03377C9.77559 9.58843 10.1829 10.0239 10.7073 10.3403C11.2316 10.6566 11.8448 10.8148 12.5468 10.8148ZM12.5468 9.34577C11.9444 9.34577 11.4873 9.14427 11.1753 8.74127C10.8676 8.33393 10.7138 7.7901 10.7138 7.10977C10.7138 6.44677 10.8611 5.90943 11.1558 5.49777C11.4548 5.08177 11.9184 4.87377 12.5468 4.87377C13.1621 4.87377 13.6236 5.07743 13.9313 5.48477C14.2389 5.88777 14.3928 6.42943 14.3928 7.10977C14.3928 7.76843 14.2389 8.30577 13.9313 8.72177C13.6279 9.13777 13.1664 9.34577 12.5468 9.34577Z", fill: "currentColor" }),
                React.createElement("path", { d: "M18.9835 10.6198H20.2055L21.7915 5.79027L23.384 10.6198H24.606L26.751 3.59977H25.217L23.839 8.10427L22.4545 3.59977H21.135L19.744 8.10427L18.3725 3.59977L16.8385 3.58677L18.9835 10.6198Z", fill: "currentColor" }),
                React.createElement("path", { d: "M31.1216 10.8148C31.7976 10.8148 32.4151 10.6414 32.9741 10.2948C33.5375 9.94377 33.9535 9.44977 34.2221 8.81277L32.6751 8.34477C32.3631 9.0121 31.815 9.34577 31.0306 9.34577C30.4976 9.34577 30.0773 9.19193 29.7696 8.88427C29.462 8.57227 29.2778 8.12593 29.2171 7.54527H34.3001C34.3608 6.70027 34.2676 5.96793 34.0206 5.34827C33.7736 4.7286 33.3945 4.24977 32.8831 3.91177C32.3761 3.57377 31.7586 3.40477 31.0306 3.40477C30.3416 3.40477 29.735 3.56077 29.2106 3.87277C28.6863 4.18043 28.2768 4.6181 27.9821 5.18577C27.6875 5.75343 27.5401 6.42077 27.5401 7.18777C27.5401 7.89843 27.6896 8.52677 27.9886 9.07277C28.292 9.61877 28.7123 10.0456 29.2496 10.3533C29.787 10.6609 30.411 10.8148 31.1216 10.8148ZM31.0956 4.77627C31.581 4.77627 31.9536 4.9041 32.2136 5.15977C32.478 5.4111 32.6448 5.81193 32.7141 6.36227H29.2561C29.4425 5.30493 30.0556 4.77627 31.0956 4.77627Z", fill: "currentColor" }),
                React.createElement("path", { d: "M36.0104 10.6198H37.5834V7.05127C37.5834 6.64393 37.6571 6.2821 37.8044 5.96577C37.9561 5.64943 38.1923 5.4046 38.5129 5.23127C38.7296 5.1056 38.9723 5.03193 39.2409 5.01027C39.5096 4.98427 39.7501 5.0016 39.9624 5.06227V3.59977C39.6461 3.5521 39.3211 3.5586 38.9874 3.61927C38.6538 3.6756 38.3569 3.7926 38.0969 3.97027C37.9496 4.06127 37.8174 4.17177 37.7004 4.30177C37.5834 4.42743 37.4816 4.56827 37.3949 4.72427V3.59977H36.0104V10.6198Z", fill: "currentColor" }),
                React.createElement("path", { d: "M44.5274 10.8148C45.2034 10.8148 45.8209 10.6414 46.3799 10.2948C46.9432 9.94377 47.3592 9.44977 47.6279 8.81277L46.0809 8.34477C45.7689 9.0121 45.2207 9.34577 44.4364 9.34577C43.9034 9.34577 43.483 9.19193 43.1754 8.88427C42.8677 8.57227 42.6835 8.12593 42.6229 7.54527H47.7059C47.7665 6.70027 47.6734 5.96793 47.4264 5.34827C47.1794 4.7286 46.8002 4.24977 46.2889 3.91177C45.7819 3.57377 45.1644 3.40477 44.4364 3.40477C43.7474 3.40477 43.1407 3.56077 42.6164 3.87277C42.092 4.18043 41.6825 4.6181 41.3879 5.18577C41.0932 5.75343 40.9459 6.42077 40.9459 7.18777C40.9459 7.89843 41.0954 8.52677 41.3944 9.07277C41.6977 9.61877 42.118 10.0456 42.6554 10.3533C43.1927 10.6609 43.8167 10.8148 44.5274 10.8148ZM44.5014 4.77627C44.9867 4.77627 45.3594 4.9041 45.6194 5.15977C45.8837 5.4111 46.0505 5.81193 46.1199 6.36227H42.6619C42.8482 5.30493 43.4614 4.77627 44.5014 4.77627Z", fill: "currentColor" }),
                React.createElement("path", { d: "M52.2307 10.8148C52.6467 10.8148 53.0215 10.7519 53.3552 10.6263C53.6888 10.5006 53.9813 10.3251 54.2327 10.0998V10.6198H55.6172V1.25977H54.0377V3.94427C53.8037 3.77093 53.5415 3.63877 53.2512 3.54777C52.9608 3.45243 52.6402 3.40477 52.2892 3.40477C51.6262 3.40477 51.0498 3.5651 50.5602 3.88577C50.0748 4.20643 49.6978 4.64627 49.4292 5.20527C49.1605 5.76427 49.0262 6.3991 49.0262 7.10977C49.0262 7.81177 49.1583 8.44227 49.4227 9.00127C49.687 9.56027 50.0597 10.0023 50.5407 10.3273C51.0217 10.6523 51.585 10.8148 52.2307 10.8148ZM52.4712 9.41077C52.0638 9.41077 51.728 9.30893 51.4637 9.10527C51.1993 8.89727 51.0022 8.61993 50.8722 8.27327C50.7465 7.9266 50.6837 7.53877 50.6837 7.10977C50.6837 6.6851 50.7487 6.29943 50.8787 5.95277C51.013 5.60177 51.2145 5.32443 51.4832 5.12077C51.7562 4.91277 52.1028 4.80877 52.5232 4.80877C53.1212 4.80877 53.5545 5.0211 53.8232 5.44577C54.0962 5.87043 54.2327 6.4251 54.2327 7.10977C54.2327 7.7901 54.0962 8.34477 53.8232 8.77377C53.5545 9.19843 53.1038 9.41077 52.4712 9.41077Z", fill: "currentColor" }),
                React.createElement("path", { d: "M60.5492 10.6198H61.9337V10.0998C62.185 10.3251 62.4775 10.5006 62.8112 10.6263C63.1448 10.7519 63.5197 10.8148 63.9357 10.8148C64.5857 10.8148 65.149 10.6523 65.6257 10.3273C66.1067 10.0023 66.4793 9.56027 66.7437 9.00127C67.008 8.44227 67.1402 7.81177 67.1402 7.10977C67.1402 6.3991 67.0058 5.76427 66.7372 5.20527C66.4728 4.64627 66.0958 4.20643 65.6062 3.88577C65.1165 3.5651 64.5402 3.40477 63.8772 3.40477C63.5262 3.40477 63.2055 3.45243 62.9152 3.54777C62.6248 3.63877 62.3627 3.77093 62.1287 3.94427V1.25977H60.5492V10.6198ZM63.6952 9.41077C63.0668 9.41077 62.6162 9.19843 62.3432 8.77377C62.0702 8.34477 61.9337 7.7901 61.9337 7.10977C61.9337 6.4251 62.068 5.87043 62.3367 5.44577C62.6097 5.0211 63.0452 4.80877 63.6432 4.80877C64.0635 4.80877 64.408 4.91277 64.6767 5.12077C64.9497 5.32443 65.1512 5.60177 65.2812 5.95277C65.4155 6.29943 65.4827 6.6851 65.4827 7.10977C65.4827 7.53877 65.4176 7.9266 65.2877 8.27327C65.162 8.61993 64.967 8.89727 64.7027 9.10527C64.4383 9.30893 64.1025 9.41077 63.6952 9.41077Z", fill: "currentColor" }),
                React.createElement("path", { d: "M69.2862 13.7398H70.7552L74.6682 3.59977H73.1017L71.1972 8.62427L69.2342 3.59977H67.6027L70.4432 10.5678L69.2862 13.7398Z", fill: "currentColor" }),
                React.createElement("path", { className: 'frontegg-logo', d: "M100.703 12.0328V7.24279H99.795V5.87242H100.703V5.00749C100.662 4.26672 100.887 3.53554 101.337 2.94505C101.755 2.44161 102.384 2.16132 103.039 2.18719C103.636 2.19392 104.225 2.33479 104.76 2.59932L104.4 3.94337C104.249 3.86598 104.09 3.80578 103.926 3.76393C103.763 3.71814 103.595 3.69361 103.426 3.69095C102.803 3.69095 102.492 4.10787 102.492 4.94169V5.87302H104.197V7.24339H102.492V12.0334L100.703 12.0328Z", fill: "currentColor" }),
                React.createElement("path", { className: 'frontegg-logo', d: "M110.833 6.60479C110.331 6.60469 109.835 6.71134 109.378 6.91762C108.972 7.09589 108.645 7.41465 108.458 7.81485V12.033H106.669V5.06155H108.311V6.55155C108.53 6.09811 108.852 5.70182 109.251 5.39412C109.598 5.11573 110.028 4.96114 110.473 4.95508C110.571 4.95508 110.644 4.95508 110.693 4.96166C110.74 4.96589 110.787 4.97248 110.833 4.9814V6.60479Z", fill: "currentColor" }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M116.223 12.1668C115.697 12.1748 115.176 12.075 114.69 11.8737C114.255 11.6918 113.862 11.4224 113.535 11.0823C113.22 10.7502 112.973 10.3596 112.808 9.93267C112.471 9.04626 112.471 8.06757 112.808 7.18116C112.972 6.75362 113.22 6.36241 113.535 6.02971C113.862 5.69004 114.255 5.42072 114.69 5.23835C115.176 5.0371 115.698 4.93754 116.224 4.94586C116.749 4.93699 117.269 5.03659 117.753 5.23835C118.618 5.60418 119.295 6.3059 119.628 7.18116C119.966 8.06741 119.966 9.04641 119.628 9.93267C119.465 10.3589 119.22 10.7496 118.908 11.0835C118.584 11.4244 118.192 11.6936 117.757 11.8737C117.271 12.0751 116.749 12.1748 116.223 12.1668ZM114.538 9.40588C114.441 9.13488 114.394 8.84889 114.397 8.56128V8.56069C114.395 8.27551 114.442 7.99208 114.538 7.72327C114.623 7.47895 114.755 7.25304 114.925 7.05753C115.087 6.87362 115.284 6.72427 115.505 6.61848C115.73 6.51154 115.976 6.45693 116.225 6.45877C116.473 6.45708 116.719 6.50933 116.945 6.6119C117.167 6.71388 117.365 6.86123 117.525 7.04437C117.696 7.23953 117.827 7.46528 117.912 7.70951C118.008 7.97835 118.055 8.26176 118.053 8.54693C118.056 8.83665 118.009 9.12474 117.912 9.3981C117.827 9.64247 117.696 9.86839 117.525 10.0638C117.364 10.2467 117.167 10.3938 116.945 10.4957C116.487 10.6993 115.963 10.6993 115.505 10.4957C115.283 10.3938 115.086 10.2467 114.925 10.0638C114.756 9.8704 114.625 9.64726 114.538 9.40588Z", fill: "currentColor" }),
                React.createElement("path", { className: 'frontegg-logo', d: "M128.892 12.033H127.104V8.12104C127.138 7.69239 127.035 7.26402 126.81 6.89721C126.619 6.64235 126.314 6.49791 125.996 6.5114C125.809 6.51306 125.623 6.54916 125.449 6.61788C125.259 6.69018 125.081 6.79104 124.921 6.91695C124.753 7.04952 124.602 7.2038 124.474 7.37574C124.341 7.55154 124.242 7.74997 124.18 7.96133V12.033H122.392V5.06088H124.007V6.3517C124.27 5.90308 124.66 5.54198 125.128 5.3139C125.642 5.05988 126.21 4.93211 126.783 4.94125C127.154 4.92596 127.523 5.00849 127.851 5.18051C128.116 5.32924 128.336 5.54432 128.491 5.80439C128.648 6.07594 128.754 6.37338 128.805 6.68248C128.863 7.01191 128.892 7.34574 128.892 7.6802V12.033Z", fill: "currentColor" }),
                React.createElement("path", { className: 'frontegg-logo', d: "M135.939 11.6736C135.65 11.7976 135.353 11.9041 135.051 11.9925C134.694 12.1002 134.323 12.1542 133.95 12.1528C133.714 12.1541 133.478 12.1227 133.25 12.0595C133.039 12.0014 132.844 11.8995 132.676 11.7604C132.505 11.6156 132.37 11.4334 132.282 11.228C132.177 10.9774 132.127 10.7074 132.135 10.4361V6.42843H131.227V5.06105H132.135V2.79883H133.923V5.06105H135.405V6.43142H133.923V9.83731C133.902 10.0344 133.977 10.2297 134.124 10.3631C134.262 10.4664 134.431 10.5201 134.604 10.5156C134.79 10.5159 134.976 10.4846 135.152 10.4229C135.329 10.3631 135.472 10.3075 135.578 10.2632L135.939 11.6736Z", fill: "currentColor" }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M139.902 11.8793C140.385 12.0754 140.903 12.1726 141.424 12.1653V12.1659C142.133 12.1848 142.832 12.0076 143.446 11.6538C143.978 11.3477 144.407 10.8915 144.68 10.3427L143.146 9.91739C143.017 10.2145 142.788 10.4569 142.498 10.6023C142.19 10.7733 141.843 10.8626 141.49 10.8619C141.262 10.8627 141.036 10.8222 140.823 10.7422C140.392 10.582 140.038 10.2631 139.835 9.851C139.724 9.62154 139.656 9.37353 139.635 9.11945H145.04C145.06 9.03204 145.071 8.94289 145.074 8.85328C145.08 8.7468 145.08 8.63615 145.08 8.5207C145.082 8.05725 144.998 7.59747 144.833 7.16409C144.674 6.73753 144.429 6.34793 144.113 6.01922C143.787 5.68396 143.396 5.41713 142.965 5.23444C142.482 5.03272 141.961 4.93313 141.437 4.94194C140.908 4.934 140.384 5.03352 139.895 5.23444C139.456 5.4168 139.059 5.68601 138.727 6.0258C138.407 6.35869 138.158 6.75256 137.994 7.18383C137.823 7.63193 137.737 8.10772 137.74 8.5871C137.738 9.0563 137.826 9.52154 138.001 9.95747C138.169 10.3842 138.42 10.7732 138.741 11.1017C139.072 11.4362 139.466 11.7007 139.902 11.8793ZM142.658 6.70579C143.007 7.03386 143.215 7.48408 143.239 7.96192L139.609 7.96311C139.623 7.71871 139.684 7.47929 139.789 7.25789C139.885 7.05351 140.019 6.86859 140.182 6.71237C140.343 6.56109 140.531 6.44136 140.736 6.35946C140.951 6.27456 141.18 6.2317 141.411 6.23325C141.872 6.22281 142.32 6.39235 142.658 6.70579Z", fill: "currentColor" }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M148.972 11.794C149.37 11.983 149.806 12.0786 150.246 12.0734C150.716 12.0758 151.179 11.9639 151.595 11.7474C152.003 11.5395 152.341 11.2183 152.57 10.8226V11.6977C152.577 11.9992 152.519 12.2986 152.402 12.5764C152.3 12.8125 152.144 13.0217 151.948 13.1877C151.752 13.3502 151.525 13.4704 151.28 13.5406C151.023 13.6167 150.756 13.6548 150.487 13.6537C150.038 13.6566 149.593 13.5613 149.185 13.3744C148.794 13.1982 148.449 12.9341 148.178 12.6027L147.204 13.5472C147.566 13.9992 148.024 14.3651 148.545 14.6185C149.156 14.8894 149.819 15.0188 150.487 14.9971C151.012 15.0023 151.534 14.9263 152.035 14.7716C152.482 14.6337 152.899 14.4125 153.263 14.1197C153.608 13.8396 153.884 13.4859 154.073 13.0848C154.269 12.6503 154.367 12.1779 154.359 11.7013V5.0618H152.799V6.28383C152.546 5.88329 152.202 5.54862 151.793 5.30765C151.356 5.0567 150.858 4.93029 150.353 4.94217C149.457 4.92843 148.6 5.31368 148.017 5.99313C147.727 6.33103 147.501 6.71851 147.35 7.1368C147.187 7.58916 147.105 8.06667 147.11 8.54725C147.107 9.00935 147.184 9.46847 147.338 9.90446C147.479 10.3155 147.697 10.6968 147.978 11.029C148.251 11.3515 148.59 11.6123 148.972 11.794ZM151.422 10.5568C151.242 10.6193 151.052 10.6509 150.862 10.6501V10.6495C150.597 10.652 150.335 10.5975 150.094 10.4898C149.862 10.386 149.653 10.2367 149.48 10.0508C149.304 9.86096 149.166 9.63974 149.073 9.39878C148.973 9.14442 148.923 8.87337 148.925 8.60024C148.925 8.32915 148.968 8.05974 149.053 7.8023C149.133 7.55354 149.257 7.32127 149.42 7.11682C149.579 6.91932 149.776 6.75643 150 6.6383C150.233 6.51725 150.492 6.4556 150.755 6.45885C151.142 6.46357 151.517 6.59445 151.822 6.8315C152.161 7.08146 152.421 7.4232 152.571 7.81606V9.47893C152.505 9.64276 152.415 9.7955 152.302 9.93173C152.188 10.0725 152.056 10.1977 151.909 10.3044C151.76 10.4117 151.596 10.4968 151.422 10.5568Z", fill: "currentColor" }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M158.615 11.794C159.013 11.983 159.449 12.0786 159.889 12.0734C160.359 12.0758 160.822 11.9639 161.238 11.7474C161.646 11.5395 161.984 11.2183 162.212 10.8226V11.6977C162.219 11.9992 162.162 12.2986 162.044 12.5764C161.943 12.8125 161.787 13.0217 161.59 13.1877C161.395 13.3502 161.168 13.4704 160.923 13.5406C160.666 13.6167 160.398 13.6548 160.13 13.6537C159.681 13.6566 159.236 13.5613 158.828 13.3744C158.437 13.1982 158.092 12.9341 157.821 12.6027L156.846 13.5472C157.208 13.9992 157.667 14.3651 158.188 14.6185C158.798 14.8894 159.462 15.0188 160.13 14.9971C160.654 15.0023 161.176 14.9263 161.677 14.7716C162.125 14.6337 162.542 14.4125 162.906 14.1197C163.25 13.8396 163.527 13.4859 163.716 13.0848C163.912 12.6503 164.01 12.1779 164.002 11.7013V5.0618H162.442V6.28383C162.189 5.88329 161.844 5.54862 161.436 5.30765C160.999 5.0567 160.501 4.93029 159.996 4.94217C159.099 4.92843 158.243 5.31368 157.66 5.99313C157.37 6.33103 157.144 6.71851 156.992 7.1368C156.829 7.58916 156.748 8.06667 156.752 8.54725C156.749 9.00935 156.827 9.46847 156.98 9.90446C157.122 10.3155 157.339 10.6968 157.62 11.029C157.894 11.3515 158.233 11.6123 158.615 11.794ZM161.065 10.5568C160.885 10.6193 160.695 10.6509 160.504 10.6501V10.6495C160.24 10.652 159.978 10.5975 159.736 10.4898C159.504 10.386 159.295 10.2367 159.122 10.0508C158.947 9.86096 158.809 9.63974 158.716 9.39878C158.616 9.14442 158.566 8.87337 158.568 8.60024C158.567 8.32915 158.611 8.05974 158.696 7.8023C158.776 7.55354 158.9 7.32127 159.063 7.11682C159.221 6.91932 159.418 6.75643 159.643 6.6383C159.875 6.51725 160.135 6.4556 160.397 6.45885C160.785 6.46357 161.159 6.59445 161.465 6.8315C161.804 7.08146 162.063 7.4232 162.213 7.81606V9.47893C162.148 9.64276 162.057 9.7955 161.945 9.93173C161.83 10.0725 161.698 10.1977 161.551 10.3044C161.402 10.4117 161.238 10.4968 161.065 10.5568Z", fill: "currentColor" }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M86.1318 0.640696C87.6679 -0.45273 89.204 -0.117165 90.6248 1.42248V1.42488C92.0457 2.96632 93.6202 5.97444 93.0801 9.1638C92.9701 9.85244 92.7363 10.5156 92.3901 11.1216C91.7109 12.2647 90.5934 13.0824 89.2958 13.3856C87.8565 13.7535 86.3296 13.5362 85.0512 12.7814C84.8891 12.6788 84.7336 12.5661 84.5856 12.4441C83.4536 11.445 82.7714 10.0348 82.6919 8.52975C82.6292 7.69245 82.691 6.85051 82.8755 6.03126C83.043 5.27862 83.2952 4.54723 83.6273 3.85099C84.1776 2.58766 85.0391 1.4834 86.1318 0.640696ZM84.9288 4.97281C85.1046 4.34774 85.725 2.52696 87.1897 1.61119C87.2628 1.56631 87.3063 1.48596 87.3039 1.40042C87.3014 1.31487 87.2534 1.23712 87.1779 1.19645C87.1023 1.15578 87.0108 1.15837 86.9377 1.20324C86.0757 1.77919 85.3928 2.58446 84.9666 3.52767C84.7608 3.95072 84.5929 4.39108 84.465 4.84361C84.447 4.90759 84.4564 4.97615 84.4912 5.03287C84.5259 5.0896 84.5827 5.12938 84.648 5.14269C84.7719 5.16878 84.8948 5.09442 84.9288 4.97281Z", fill: "currentColor" }),
                React.createElement("path", { className: 'frontegg-logo', d: "M89.0883 14.5244C90.9056 15.3547 93.0387 15.0798 94.5845 13.8162C97.1862 11.6497 97.9068 7.22397 97.9068 7.22397C97.9068 7.22397 98.3665 4.93124 97.5204 3.60812C96.6744 2.28501 94.5845 2.29637 92.6722 2.95015C93.5268 4.68805 93.9974 6.58848 94.0523 8.52316C94.0281 11.4408 91.9581 13.9432 89.0895 14.5226", fill: "currentColor" }))));
};

const CompanyPlaceholder = () => {
    return React.createElement("svg", { width: "161", height: "32", viewBox: "0 0 161 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M113.765 8.66072C112.013 8.66072 111.262 10.1626 111.262 11.5643L111.287 17.6719H107.857V0H111.212V7.78464H111.287C111.862 6.58316 112.964 5.70706 114.866 5.70706C117.795 5.70706 119.297 7.73458 119.297 10.4129V17.6719H115.842V11.0136C115.842 9.61188 115.166 8.66072 113.765 8.66072ZM55.9935 4.86374e-05H59.4227V17.6719H55.9935V4.86374e-05ZM9.66134 17.6713H6.1069V11.739L0.5 1.15086H4.32974L7.10814 6.70771C7.44154 7.36408 7.70987 8.05153 7.90918 8.76023H7.98422C8.17326 8.05172 8.43325 7.36408 8.76021 6.70771L11.5136 1.15086H15.2432L9.66134 11.6638V17.6713ZM158.385 27.4094L158.475 27.3043C159.035 27.2597 159.598 27.2597 160.157 27.3043H158.966C158.966 27.4368 157.474 28.7016 156.423 29.5922L156.423 29.5926L156.422 29.5928C155.886 30.0472 155.465 30.404 155.416 30.4632C154.661 30.5241 153.749 30.5251 152.803 30.526C151.65 30.5272 150.446 30.5284 149.409 30.6384C149.612 30.6529 149.438 30.658 149.209 30.6647C148.885 30.674 148.452 30.6866 148.818 30.7335H147.627C148.003 30.733 148.378 30.6978 148.748 30.6284C147.021 30.6116 145.201 30.6173 143.418 30.6229H143.417H143.416H143.416H143.415H143.415H143.414H143.414H143.413H143.413H143.412H143.412H143.411C142.535 30.6257 141.667 30.6284 140.823 30.6284C140.022 30.6177 139.221 30.678 138.43 30.8086L138.501 30.7335H136.954C137.057 30.7631 137.084 30.7989 137.111 30.8338C137.155 30.8932 137.198 30.9499 137.614 30.9688C137.264 31.0065 136.91 31.0165 136.558 30.9988C136.743 30.9838 137.139 30.9087 136.808 30.9087C136.198 30.9062 136.106 30.9217 135.977 30.9436C135.852 30.9647 135.693 30.9917 134.996 31.0139C134.999 31.0111 135.033 31.0052 135.08 30.9971C135.289 30.9607 135.75 30.8805 134.801 30.8437C132.992 30.8091 125.911 30.8733 120.126 30.9259H120.125H120.125L120.125 30.9259H120.125H120.124L120.124 30.9259L120.124 30.9259L120.123 30.9259L120.122 30.9259L120.122 30.9259H120.122C116.751 30.9565 113.821 30.9831 112.631 30.9838C112.722 30.9714 112.873 30.9028 113.022 30.8348C113.172 30.7668 113.32 30.6995 113.405 30.6897L111.973 30.7786L112.754 30.8737C111.828 30.9668 108.533 31.057 105.437 31.1416L105.437 31.1416H105.437C102.875 31.2117 100.45 31.2781 99.6175 31.3393H100.118C98.6766 31.4444 97.6354 31.4444 95.9039 31.4444L96.9742 31.3994C96.2042 31.2813 95.4235 31.2493 94.6464 31.3042L95.2921 31.3493C94.485 31.4381 93.7713 31.4286 92.8013 31.4156L92.8009 31.4156H92.8008H92.8007C92.4052 31.4103 91.9669 31.4044 91.4624 31.4044L92.1283 31.4394H90.7365C91.2939 31.3996 90.9371 31.3785 90.5095 31.3532C90.2381 31.3372 89.9382 31.3195 89.8254 31.2942C90.4061 31.4344 88.6639 31.4344 88.1633 31.4344C88.0343 31.3979 87.6497 31.4193 87.2777 31.4401C86.8844 31.4621 86.5051 31.4833 86.4562 31.4344C85.9872 31.4604 86.2717 31.5129 86.4697 31.5263C85.879 31.5056 85.3251 31.5365 84.6382 31.5749L84.638 31.5749C84.0144 31.6097 83.2811 31.6507 82.3111 31.6646C80.8646 31.6626 80.5019 31.6494 80.325 31.6429L80.2784 31.6413C80.2618 31.6407 80.2464 31.6403 80.231 31.6399C80.128 31.6378 80.0247 31.6415 79.551 31.6585L79.5504 31.6585L79.5501 31.6585L79.55 31.6585L79.5498 31.6585C79.2037 31.6709 78.6602 31.6904 77.7755 31.7198L77.315 31.6547L77.0496 31.7648C76.7018 31.6704 76.1135 31.6611 75.5651 31.6523C75.0084 31.6435 74.4928 31.6353 74.3113 31.5395C74.1217 31.5676 73.9257 31.5661 73.676 31.5643C73.3915 31.5622 73.0374 31.5596 72.5441 31.5996C72.7823 31.6838 73.2467 31.6922 73.6824 31.7001C73.9974 31.7057 74.2974 31.7112 74.4865 31.7448C71.633 31.8019 60.7341 31.7892 55.0464 31.7825H55.0461H55.0459H55.0454H55.0448L55.0403 31.7825C53.7557 31.781 52.7376 31.7798 52.1388 31.7798C52.6695 31.7648 52.5644 31.6997 52.0637 31.6697L50.8172 31.7148C50.8717 31.7257 50.9514 31.7326 51.0213 31.7387C51.144 31.7494 51.2369 31.7575 51.1126 31.7798C50.6362 31.7528 50.1583 31.7729 49.6858 31.8399C49.7359 31.7598 48.8898 31.7598 48.8898 31.7598C48.6426 31.8042 48.1018 31.7932 47.5077 31.7812H47.5077H47.5077C46.6946 31.7648 45.7818 31.7463 45.3855 31.8649C44.5072 31.8849 44.4044 31.8562 44.2836 31.8224C44.1628 31.7886 44.0241 31.7498 43.0727 31.7498L42.9525 31.89C42.7923 31.8749 32.7999 31.935 33.0903 32.0001C32.8401 31.9339 32.583 31.897 32.3243 31.89C31.428 31.9129 30.5421 31.9229 29.6327 31.9331H29.6325C28.7592 31.9429 27.8643 31.953 26.9177 31.975C26.9555 31.972 26.993 31.9695 27.0274 31.9673H27.0274C27.1612 31.9586 27.2484 31.9529 27.1329 31.925C22.8657 31.9783 18.7162 31.9606 14.5484 31.9428H14.5484H14.5484H14.5483H14.5483H14.5483H14.5483H14.5483H14.5483H14.5482H14.5482H14.5482H14.5482L14.5473 31.9428C12.4567 31.9339 10.3616 31.925 8.24459 31.925C7.62166 31.9224 7.58008 31.8875 7.54076 31.8545C7.50423 31.8238 7.46965 31.7948 6.97306 31.7948C6.4717 31.7719 5.91181 31.8103 5.43433 31.8432C5.28724 31.8533 5.14797 31.8628 5.02063 31.8699C5.07251 31.8766 5.14564 31.8811 5.21273 31.8852C5.34634 31.8933 5.45598 31.9 5.326 31.92C4.99084 31.885 4.58073 31.885 4.16054 31.885H4.15958C4.21024 31.879 4.26625 31.8729 4.32306 31.8666H4.32308C4.60306 31.8357 4.90256 31.8027 4.67651 31.7878C4.53787 31.788 4.38391 31.7858 4.21464 31.7798H3.3836L3.44868 31.7047C-0.776536 31.1591 2.53752 28.4657 2.53752 28.4657H2.83794L4.9055 28.676C7.12199 28.5822 9.57473 28.6186 11.6681 28.6496C12.5913 28.6633 13.4446 28.676 14.1769 28.676C14.4532 28.672 14.8487 28.6705 15.3079 28.6687H15.3079H15.3079H15.3079H15.308H15.308H15.308C16.5791 28.6638 18.3382 28.6571 19.4084 28.5909L19.3383 28.6659C20.4283 28.6472 21.773 28.5872 22.8857 28.5376L22.8858 28.5376C23.5516 28.5079 24.1343 28.4819 24.5297 28.4707L24.5047 28.5008C25.2005 28.4908 27.0378 28.3956 26.8175 28.2555C27.993 28.3524 29.1731 28.3808 30.3519 28.3406H30.0215C31.2901 28.3042 35.1261 28.3029 38.817 28.3016C42.2339 28.3005 45.5263 28.2994 46.5419 28.2705L46.3467 28.3055C47.2384 28.2632 48.2294 28.2565 49.2313 28.2498H49.2314C50.4793 28.2415 51.744 28.2331 52.8547 28.1553C56.5943 28.2104 72.7193 28.2104 76.9295 28.1103C78.7417 28.0805 78.829 28.0508 78.895 28.0283C78.9622 28.0054 79.0072 27.9901 80.8343 27.9901C81.3499 27.9901 81.5752 27.9301 80.9144 27.895C81.2882 27.9013 81.7003 27.9027 82.1249 27.9041C83.0481 27.9071 84.0308 27.9103 84.8092 27.9651C89.843 27.8555 98.2731 27.7858 105.376 27.727C108.658 27.6999 111.656 27.675 113.905 27.6497H113.72C115.267 27.6365 118.319 27.6018 121.878 27.5613L121.887 27.5612L121.892 27.5611L121.898 27.5611L121.9 27.561L121.903 27.561C129.082 27.4794 138.313 27.3744 141.419 27.3744L142.355 27.2792C142.856 27.3075 143.34 27.3081 143.873 27.3087C144.379 27.3093 144.929 27.31 145.579 27.3343C146.21 27.3208 146.038 27.2546 145.756 27.2415C146.291 27.2526 146.843 27.243 147.343 27.2344L147.343 27.2344C147.905 27.2246 148.401 27.216 148.733 27.2392L148.538 27.2693C149.437 27.3088 150.148 27.2727 150.877 27.2357C151.626 27.1976 152.395 27.1586 153.409 27.1992C154.232 27.2159 155.056 27.1908 155.877 27.1241C156.404 27.1424 156.401 27.1718 156.398 27.2006C156.395 27.2268 156.392 27.2526 156.788 27.2693C157.497 27.1987 158.21 27.187 158.921 27.2342C157.935 27.2492 156.818 27.2742 156.883 27.3643C157.47 27.357 157.546 27.3781 157.613 27.3965C157.684 27.416 157.744 27.4325 158.385 27.4094ZM145.659 27.2392L145.756 27.2415C145.725 27.24 145.692 27.2392 145.659 27.2392ZM86.4697 31.5263L86.523 31.5283L86.5514 31.5295C86.5391 31.5295 86.5254 31.5292 86.5107 31.5286L86.4927 31.5277L86.4697 31.5263ZM112.584 30.9838C112.597 30.9865 112.613 30.9863 112.631 30.9838L112.584 30.9838ZM5.10314 31.7798H5.61133C5.64248 31.7531 5.56783 31.7571 5.38739 31.7667C5.3114 31.7707 5.21665 31.7757 5.10314 31.7798ZM20.0243 17.8233C23.7539 17.8233 26.232 15.3202 26.232 11.7658C26.232 8.21139 23.7289 5.70831 20.0243 5.70831C16.3197 5.70831 13.7916 8.21139 13.7916 11.7658C13.7916 15.3202 16.2697 17.8233 20.0243 17.8233ZM20.0243 8.51176C21.7014 8.51176 22.7526 9.86343 22.7526 11.7658C22.7526 13.6681 21.7014 15.0198 20.0243 15.0198C18.3472 15.0198 17.2709 13.6932 17.2709 11.7658C17.2709 9.8384 18.3222 8.51176 20.0243 8.51176ZM34.8647 17.2262C34.2064 17.6591 33.4261 17.8683 32.6396 17.8227C29.711 17.8227 28.2091 15.7952 28.2091 13.1169V5.85795H31.6634V12.5161C31.6634 13.9179 32.3643 14.8691 33.741 14.8691C35.2929 14.8691 36.0689 13.3422 36.0689 11.9655V5.85795H39.4981V17.6725L36.7196 17.7726C36.527 17.0006 36.4014 16.2134 36.3442 15.4198H36.2941C36.0242 16.1599 35.5229 16.7934 34.8647 17.2262ZM45.6057 11.9649C45.6057 9.98746 46.7321 8.9612 48.0337 8.9612C48.518 8.95606 48.9914 9.10508 49.3854 9.38671L50.2865 6.08264C49.7335 5.84415 49.1365 5.72477 48.5343 5.73223C46.7571 5.73223 45.831 6.88362 45.3805 8.38547H45.2803C45.2397 7.50419 45.0969 6.63062 44.8548 5.78228L42.1765 5.88238V17.697H45.6057V11.9649ZM67.733 17.8233C71.4626 17.8233 73.9406 15.3202 73.9406 11.7658C73.9406 8.21139 71.4376 5.70831 67.733 5.70831C64.0284 5.70831 61.5003 8.21139 61.5003 11.7658C61.5003 15.3202 63.9784 17.8233 67.733 17.8233ZM67.733 8.51176C69.4101 8.51176 70.4613 9.86343 70.4613 11.7658C70.4613 13.6681 69.4101 15.0198 67.733 15.0198C66.0559 15.0198 64.9796 13.6932 64.9796 11.7658C64.9796 9.8384 66.0209 8.51176 67.733 8.51176ZM87.6078 19.0999C87.6078 20.9772 86.2311 22.9296 81.1498 22.9296C76.8195 22.9296 74.8671 21.6781 74.8671 19.8759C74.8671 18.6994 75.618 17.8984 76.8445 17.4979C76.4399 17.2822 76.1009 16.9615 75.8631 16.5695C75.6252 16.1775 75.4974 15.7286 75.4929 15.2702C75.4998 14.7682 75.6694 14.2821 75.9764 13.8848C76.2833 13.4876 76.711 13.2008 77.1949 13.0675C76.7783 12.6883 76.4486 12.2236 76.2283 11.7052C76.0079 11.1868 75.9022 10.6268 75.9184 10.0638C75.9184 7.48558 77.9959 5.70835 81.1498 5.70835C82.2261 5.68567 83.2916 5.92628 84.2537 6.40923C85.0547 5.95867 85.3801 4.83227 85.3801 3.58072L87.9582 4.25655C87.9647 4.98466 87.7265 5.69386 87.2816 6.27033C86.8368 6.84679 86.2112 7.25716 85.5053 7.43552C86.14 8.16176 86.4793 9.09954 86.4564 10.0638C86.4564 12.642 84.3538 14.3941 81.1749 14.3941C80.4359 14.4077 79.6999 14.2977 78.9972 14.0687C78.4465 14.1939 78.1712 14.4191 78.1712 14.7946C78.1712 15.3953 78.6718 15.5956 80.0735 15.5956H82.7268C85.6054 15.5956 87.6078 16.6969 87.6078 19.0999ZM83.3025 10.0888C83.3276 8.9874 82.4765 8.18645 81.2249 8.18645C79.9734 8.18645 79.1974 8.88727 79.1474 10.0137C79.0973 11.1401 79.8482 11.916 81.1498 11.916C82.4514 11.916 83.2775 11.1901 83.3025 10.0888ZM82.4014 18.1988H80.1737V18.1738C78.4715 18.1738 77.8958 18.6243 77.8958 19.3252C77.8958 20.1512 78.6968 20.5768 81.1498 20.5768C83.6029 20.5768 84.4539 20.1011 84.4539 19.2751C84.4539 18.4491 83.8031 18.1988 82.4014 18.1988ZM94.5561 17.8233C98.2857 17.8233 100.764 15.3202 100.764 11.7658C100.764 8.21139 98.2857 5.70831 94.5561 5.70831C90.8265 5.70831 88.3234 8.21139 88.3234 11.7658C88.3234 15.3202 90.7865 17.8233 94.5561 17.8233ZM94.5561 8.51176C96.2332 8.51176 97.2845 9.86343 97.2845 11.7658C97.2845 13.6681 96.2332 15.0198 94.5561 15.0198C92.879 15.0198 91.8027 13.6932 91.8027 11.7658C91.8027 9.8384 92.839 8.51176 94.5561 8.51176ZM127.632 17.8233C130.185 17.8233 131.912 16.8221 132.713 15.7457L131.086 13.8684C130.711 14.3086 130.242 14.6586 129.713 14.8926C129.185 15.1266 128.61 15.2385 128.032 15.2201C126.08 15.2201 124.979 14.1187 124.678 12.5418H132.638C132.709 12.1284 132.742 11.7095 132.738 11.2902C132.738 8.06122 130.736 5.70831 127.306 5.70831C123.652 5.70831 121.269 8.23642 121.269 11.7658C121.269 15.2951 123.652 17.8233 127.632 17.8233ZM127.306 8.31156C128.733 8.31156 129.584 9.36281 129.609 10.7645H124.678C124.929 9.18759 125.955 8.31156 127.306 8.31156ZM140.748 8.96116C139.442 8.96116 138.315 9.98743 138.315 11.9649V17.697H134.886V5.88234L137.564 5.78224C137.807 6.63058 137.949 7.50415 137.99 8.38544H138.09C138.541 6.88358 139.467 5.73219 141.249 5.73219C141.851 5.72518 142.448 5.84454 143.001 6.0826L142.1 9.38667C141.706 9.10598 141.233 8.95706 140.748 8.96116ZM149.734 17.8233C152.287 17.8233 154.014 16.8221 154.815 15.7457L153.188 13.8684C152.814 14.3086 152.344 14.6586 151.816 14.8926C151.287 15.1266 150.713 15.2385 150.135 15.2201C148.177 15.2201 147.076 14.1187 146.781 12.5418H154.74C154.811 12.1284 154.845 11.7095 154.841 11.2902C154.841 8.06122 152.838 5.70831 149.409 5.70831C145.754 5.70831 143.371 8.23642 143.371 11.7658C143.371 15.2951 145.754 17.8233 149.734 17.8233ZM149.409 8.31156C150.836 8.31156 151.687 9.36281 151.712 10.7645H146.781C147.031 9.18759 148.052 8.31156 149.409 8.31156ZM159.6 17.4925C159.279 17.7071 158.901 17.8216 158.515 17.8216C157.998 17.8203 157.502 17.6141 157.136 17.2483C156.77 16.8824 156.564 16.3866 156.563 15.8692C156.563 15.483 156.677 15.1055 156.892 14.7845C157.106 14.4634 157.411 14.2131 157.768 14.0654C158.125 13.9176 158.517 13.8789 158.896 13.9543C159.275 14.0296 159.622 14.2156 159.896 14.4886C160.169 14.7617 160.355 15.1095 160.43 15.4883C160.505 15.867 160.467 16.2596 160.319 16.6163C160.171 16.9731 159.921 17.278 159.6 17.4925Z", fill: "#b7b7bb" }));
};
var CompanyPlaceholder$1 = CompanyPlaceholder;

const loginBoxStyler = createStyled();
const Container$2 = loginBoxStyler(Box)(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ color: '#a9a9ab', marginTop: '.5rem', marginBottom: '2rem', width: '100%', textAlign: (_b = (_a = theme.logo) === null || _a === void 0 ? void 0 : _a.alignment) !== null && _b !== void 0 ? _b : 'center', height: '50px', '& .MuiCompanyLogo-img': {
            maxWidth: '100%',
            maxHeight: '100%',
        } }, (_c = theme.logo) === null || _c === void 0 ? void 0 : _c.style));
});
const CompanyLogo$1 = (props) => {
    var _a, _b;
    const { logo } = useTheme();
    let component;
    if ((_b = (_a = logo === null || logo === void 0 ? void 0 : logo.image) === null || _a === void 0 ? void 0 : _a.startsWith) === null || _b === void 0 ? void 0 : _b.call(_a, 'http')) {
        component = React.createElement("img", { className: "MuiCompanyLogo-img", src: logo === null || logo === void 0 ? void 0 : logo.image, alt: "company-logo" });
    }
    else {
        component = React.createElement(UnstyledCustomComponent, { componentKey: "logo.image" },
            React.createElement(CompanyPlaceholder$1, null));
    }
    return React.createElement(Container$2, Object.assign({}, props), component);
};

const styled$1 = createStyled();
const BoxCustomComponents$1 = CustomComponent;
const BoxElementContainer = styled$1(Card)(({ theme: { spacing, palette, boxStyle } }) => (Object.assign({ overflow: 'auto', maxWidth: '90%', boxSizing: 'border-box', width: '480px', padding: spacing(8), border: 'none', borderRadius: '9px', boxShadow: ' 0 0 43px 7px rgba(0, 0, 0, 0.12)', backgroundCard: palette.common.white }, boxStyle)));
const BoxElement = ({ children, themeOptionKey }) => {
    const { poweredByPlacement, logo } = useTheme();
    return React.createElement(BoxElementContainer, null,
        (logo === undefined || (logo === null || logo === void 0 ? void 0 : logo.placement) === undefined || logo.placement == 'box') && React.createElement(CompanyLogo$1, null),
        React.createElement(BoxCustomComponents$1, { componentKey: 'boxHeader', className: `fe-${themeOptionKey}-box-header` }),
        children,
        React.createElement(BoxCustomComponents$1, { componentKey: 'boxFooter', className: `fe-${themeOptionKey}-box-title` }),
        (!poweredByPlacement || poweredByPlacement === 'box') && React.createElement(PowerByFrontegg, null));
};
var BoxElement$1 = BoxElement;

const styled = createStyled();
const BoxCustomComponents = CustomComponent;
const PageElementContainer = styled(Box)(({ theme }) => ({
    flex: 1,
    height: '100vh',
    overflow: 'auto',
}));
const Container$1 = styled(Box)(({ theme: { pageStyle } }) => (Object.assign({ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '2rem 0', boxSizing: 'border-box' }, pageStyle)));
const PageElement = ({ children, themeOptionKey }) => {
    const { poweredByPlacement, logo, layout } = useTheme();
    return React.createElement(React.Fragment, null,
        React.createElement(PageElementContainer, { className: 'fe-page-container-element' },
            React.createElement(Container$1, null,
                (logo === null || logo === void 0 ? void 0 : logo.placement) == 'page' && React.createElement(CompanyLogo$1, null),
                React.createElement(BoxCustomComponents, { componentKey: 'pageHeader', className: `fe-${themeOptionKey}-page-header` }),
                children,
                React.createElement(BoxCustomComponents, { componentKey: 'pageFooter', className: `fe-${themeOptionKey}-page-footer` }),
                poweredByPlacement === 'page' && React.createElement(PowerByFrontegg, null))),
        ((layout === null || layout === void 0 ? void 0 : layout.type) === 'float-left' || (layout === null || layout === void 0 ? void 0 : layout.type) === 'float-right') &&
            React.createElement(CustomComponent, { componentKey: "layout.sideElement", className: 'fe-page-side-element' }));
};
var PageElement$1 = PageElement;

const wrapPage = (Component, themeOptionKey) => () => {
    return React.createElement(RootElement$1, { themeOptionKey: themeOptionKey },
        React.createElement(PageElement$1, { themeOptionKey: themeOptionKey },
            React.createElement(BoxElement$1, { themeOptionKey: themeOptionKey },
                React.createElement(Component, null))));
};
const wrapPageWithoutBox = (Component, themeOptionKey) => () => {
    return React.createElement(RootElement$1, { themeOptionKey: themeOptionKey },
        React.createElement(PageElement$1, { themeOptionKey: themeOptionKey },
            React.createElement(Component, null)));
};

const LoginErrorMessage = styled$3(Alert$1)(({ theme }) => ({
    padding: '0.5rem 1rem',
    marginBottom: theme.spacing(2),
}));
LoginErrorMessage.defaultProps = {
    className: 'fe-alert-error',
    severity: 'error',
};

const FromWrapper = (props) => {
    const { initialValues, validationSchema, onSubmit, children, enableReinitialize, validateOnBlur } = props;
    const [formError, setFormError] = react.exports.useState(null);
    const formikProps = {
        onSubmit: (values, formikHelpers) => __awaiter(void 0, void 0, void 0, function* () {
            setFormError(null);
            try {
                yield onSubmit(values, formikHelpers);
            }
            catch (e) {
                setFormError(e.message);
            }
        }),
        enableReinitialize,
        initialValues,
        validationSchema,
        validateOnBlur,
    };
    return React.createElement(Formik, Object.assign({}, formikProps), props => {
        const canSubmit = !props.isSubmitting && props.isValid && props.dirty;
        return React.createElement(Form, { autoComplete: 'on' }, children === null || children === void 0 ? void 0 : children(Object.assign(Object.assign({}, props), { canSubmit, formError })));
    });
};

const ReCaptcha = ({ action, fieldName = 'recaptchaToken', recaptchaRef }) => {
    const { setFieldValue } = useFormikContext();
    const recaptcha = useRecaptcha({ action, recaptchaRef });
    const token = recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token;
    react.exports.useEffect(() => {
        token && setFieldValue(fieldName, token, true);
    }, [fieldName, token, setFieldValue]);
    return React.createElement(React.Fragment, null, recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.component);
};

var SocialLoginsActions;
(function (SocialLoginsActions) {
    SocialLoginsActions["Login"] = "login";
    SocialLoginsActions["SignUp"] = "signUp";
    SocialLoginsActions["Activation"] = "activation";
})(SocialLoginsActions || (SocialLoginsActions = {}));

const SocialLoginsContext = react.exports.createContext({ action: SocialLoginsActions.Login });

const FRONTEGG_CODE_VERIFIER = 'FRONTEGG_CODE_VERIFIER';
const FRONTEGG_INVITATION_TOKEN = 'fe-invitation-token';

const SocialLogins = (props) => {
    const { firstLoad, socialLoginsConfigV2, error } = useSocialLoginState(({ firstLoad, socialLoginsConfigV2, error }) => ({
        firstLoad,
        socialLoginsConfigV2,
        error,
    }));
    const { loadSocialLoginsConfigurationV2 } = useSocialLoginActions();
    react.exports.useEffect(() => {
        if (firstLoad) {
            loadSocialLoginsConfigurationV2();
        }
    }, [loadSocialLoginsConfigurationV2, firstLoad]);
    react.exports.useEffect(() => {
        const url = new URL(window.location.href);
        const invitationToken = url.searchParams.get('invitationToken');
        if (invitationToken) {
            localStorage.setItem(FRONTEGG_INVITATION_TOKEN, invitationToken);
        }
        return () => {
            localStorage.removeItem(FRONTEGG_INVITATION_TOKEN);
        };
    }, [window.location.search]);
    if (!(socialLoginsConfigV2 === null || socialLoginsConfigV2 === void 0 ? void 0 : socialLoginsConfigV2.some(({ active }) => active))) {
        return null;
    }
    let component = React.createElement(SocialLoginsContext.Provider, { value: { action: props.action } }, props.children);
    if (error) {
        component = React.createElement("div", { className: "fe-error-message" }, error);
    }
    if (firstLoad) {
        component = React.createElement(Loader$1, null);
    }
    return React.createElement(Box, { textAlign: "center", mt: 4 }, component);
};

const socialLoginStyler = createStyled();
const SocialLoginCustomComponent = CustomComponent;

const DividerWrapper = socialLoginStyler(Box)(({ theme }) => (Object.assign({ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', color: '#CDD3DF', '& > div:first-of-type': {
        height: '1px',
        backgroundColor: 'currentColor',
        flex: 1,
        marginRight: '1rem',
    }, '& > div:last-of-type': {
        height: '1px',
        backgroundColor: 'currentColor',
        flex: 1,
        marginLeft: '1rem',
    } }, theme.dividerStyle)));
const DividerText = socialLoginStyler(Box)(({ theme }) => (Object.assign({ marginBottom: '0.5rem', marginTop: '0.5rem', fontStyle: 'normal', fontWeight: 800, fontSize: '0.625rem', lineHeight: '1rem', display: 'flex', alignItems: 'center', textAlign: 'center', textTransform: 'uppercase', color: '#99A0AF' }, theme.dividerTextStyle)));
const SocialLoginDivider = ({ children }) => {
    return (React.createElement(SocialLoginCustomComponent, { componentKey: 'divider', className: 'fe-social-login-divider', text: children },
        React.createElement(DividerWrapper, null,
            React.createElement("div", null),
            React.createElement(DividerText, null, children),
            React.createElement("div", null))));
};

const enhancedSocialButtonStyle = (style) => {
    if (!style || typeof style !== 'object') {
        return {};
    }
    const { base, hover, active, focus, icon } = style;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, base), (icon ? { '& svg path': icon } : {})), (hover ? { '&:hover:not(.Mui-disabled)': hover } : {})), (focus ? { '&:focus:not(.Mui-disabled)': focus } : {})), (active ? { '&:active:not(.Mui-disabled)': active } : {}));
};
const SocialLoginButton = socialLoginStyler(Button$1$1)(({ theme }) => ({
    '&.MuiButton-root': {
        margin: '0.5rem',
        flex: 'inherit',
        '&.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(theme.buttonStyle)),
    },
}));

const FacebookIcon = (props) => {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1365 1365", fill: "white" }, props),
        React.createElement("g", { xmlns: "http://www.w3.org/2000/svg", transform: "matrix(1.3333333,0,0,-1.3333333,0,1365.3333)", id: "g10" },
            React.createElement("g", { transform: "scale(0.1)", id: "g12" },
                React.createElement("path", { fill: "#4267B2", d: "m 10240,5120 c 0,2827.7 -2292.3,5120 -5120,5120 C 2292.3,10240 0,7947.7 0,5120 0,2564.46 1872.31,446.301 4320,62.1992 V 3640 H 3020 v 1480 h 1300 v 1128 c 0,1283.2 764.38,1992 1933.9,1992 560.17,0 1146.1,-100 1146.1,-100 V 6880 H 6754.38 C 6118.35,6880 5920,6485.33 5920,6080.43 V 5120 H 7340 L 7113,3640 H 5920 V 62.1992 C 8367.69,446.301 10240,2564.46 10240,5120" })))));
};
const GoogleIcon = (props) => {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", fill: "none" }, props),
        React.createElement("path", { fill: "#FFC107", d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" }),
        React.createElement("path", { fill: "#FF3D00", d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" }),
        React.createElement("path", { fill: "#4CAF50", d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" }),
        React.createElement("path", { fill: "#1976D2", d: "M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" })));
};
const GithubIcon = (props) => {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 16", fill: "none" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.50001 -0.0010302C6.55044 -0.00301169 4.66389 0.689346 3.17843 1.95197C1.69296 3.2146 0.705689 4.96496 0.39354 6.88938C0.0813902 8.81379 0.464767 10.7865 1.47496 12.4539C2.48515 14.1213 4.05613 15.3745 5.90637 15.9889C6.3143 16.0644 6.46539 15.8076 6.46539 15.591C6.46539 15.3745 6.46539 14.8809 6.46539 14.196C4.18399 14.6996 3.70051 13.0981 3.70051 13.0981C3.54849 12.6018 3.22554 12.1753 2.78896 11.8945C2.04864 11.3908 2.84939 11.3908 2.84939 11.3908C3.10891 11.4275 3.35668 11.5227 3.57394 11.6693C3.7912 11.8159 3.97227 12.01 4.10341 12.2369C4.21484 12.439 4.36507 12.617 4.54548 12.7609C4.7259 12.9047 4.93294 13.0115 5.15474 13.0752C5.37653 13.1388 5.6087 13.158 5.83794 13.1317C6.06717 13.1054 6.28896 13.0341 6.49056 12.9219C6.52217 12.5076 6.70078 12.1182 6.99418 11.824C5.17108 11.6175 3.25732 10.9124 3.25732 7.76982C3.24481 6.95546 3.54594 6.16747 4.09837 5.569C3.85183 4.861 3.8806 4.08618 4.17895 3.3984C4.17895 3.3984 4.86891 3.17681 6.43516 4.23945C7.78012 3.87017 9.19974 3.87017 10.5447 4.23945C12.111 3.17681 12.7959 3.3984 12.7959 3.3984C13.0974 4.0852 13.1279 4.8606 12.8815 5.569C13.4339 6.16747 13.7351 6.95546 13.7225 7.76982C13.7225 10.9225 11.8038 11.6124 9.97561 11.7988C10.1716 11.9958 10.323 12.2327 10.4195 12.4934C10.5159 12.7541 10.5552 13.0324 10.5346 13.3096C10.5346 14.4075 10.5346 15.2939 10.5346 15.5608C10.5346 15.8277 10.6807 16.0342 11.0987 15.9587C12.9431 15.3385 14.5072 14.0833 15.5121 12.417C16.517 10.7507 16.8973 8.78157 16.5852 6.86089C16.273 4.94021 15.2887 3.19286 13.8079 1.93051C12.327 0.668166 10.4459 -0.027091 8.50001 -0.03125V-0.0010302Z", fill: "#231E1B" })));
};
const MicrosoftIcon = (props) => {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" }, props),
        React.createElement("path", { d: "M7.60384 7.60256H0.00128174V0H7.60384V7.60256Z", fill: "#F1511B" }),
        React.createElement("path", { d: "M15.9987 7.60256H8.39552V0H15.9981V7.60256H15.9987Z", fill: "#80CC28" }),
        React.createElement("path", { d: "M7.60384 16.001H0.00128174V8.39844H7.60384V16.001Z", fill: "#00ADEF" }),
        React.createElement("path", { d: "M15.9987 16.001H8.39552V8.39844H15.9981V16.001H15.9987Z", fill: "#FBBC09" })));
};

const createSocialLoginState = (state) => JSON.stringify(state);
const useRedirectUri = () => {
    const routes = useAuthRoutes();
    const { basename = '/', urlStrategy } = useShadowDom();
    const calculatedBasename = basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '';
    return react.exports.useMemo(() => `${window.location.origin}${urlStrategy === 'path' ? '' : '#'}${calculatedBasename}${routes.socialLoginCallbackUrl}`, [routes.socialLoginCallbackUrl, calculatedBasename, urlStrategy]);
};
const useRedirectUrl = (urlCreator, socialLoginType) => {
    const { action } = useSocialLoginContext();
    const { socialLoginsConfigV2 } = useSocialLoginState(({ socialLoginsConfigV2 }) => ({ socialLoginsConfigV2 }));
    const config = react.exports.useMemo(() => socialLoginsConfigV2 === null || socialLoginsConfigV2 === void 0 ? void 0 : socialLoginsConfigV2.find(({ type }) => type.toLowerCase() === socialLoginType.toLowerCase()), [socialLoginsConfigV2, socialLoginType]);
    const redirectUri = useRedirectUri();
    const redirectUrl = react.exports.useMemo(() => {
        var _a;
        if (config) {
            if (config.customised) {
                return urlCreator(Object.assign(Object.assign({}, config), { redirectUrl: redirectUri, state: createSocialLoginState({ provider: socialLoginType, action }) }));
            }
            else {
                return (_a = `${config.authorizationUrl}${window.location.search}`) !== null && _a !== void 0 ? _a : undefined;
            }
        }
    }, [config, redirectUri, socialLoginType, action, urlCreator]);
    if (!(config === null || config === void 0 ? void 0 : config.active) || !redirectUrl) {
        return null;
    }
    return redirectUrl;
};
const useSocialLoginContext = () => {
    const context = react.exports.useContext(SocialLoginsContext);
    if (!context) {
        throw new Error('Social Login compound component cannot be rendered outside SocialLogins component');
    }
    return context;
};

const createGoogleUrl = ({ clientId, redirectUrl, state }) => {
    const searchParams = new URLSearchParams({
        redirect_uri: redirectUrl,
        response_type: 'code',
        include_granted_scopes: 'true',
        scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
        state,
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://accounts.google.com/o/oauth2/v2/auth');
    url.search = searchParams.toString();
    return url.toString();
};
const Button$3 = socialLoginStyler(SocialLoginButton)(({ theme }) => ({
    '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(theme.googleButtonStyle))
}));
const GoogleLoginButton = () => {
    const onRedirectTo = useOnRedirectTo();
    const { iconsOnly } = useTheme();
    const redirectUrl = useRedirectUrl(createGoogleUrl, SocialLoginProviders.Google);
    const handleClick = react.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = React.createElement(SocialLoginCustomComponent, { componentKey: "googleIcon", className: "fe-social-login-google-icon" },
        React.createElement(GoogleIcon, null));
    if (redirectUrl) {
        return React.createElement(Button$3, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Google' });
    }
    return null;
};
var GoogleLoginButton$1 = GoogleLoginButton;

const createGithubUrl = ({ clientId, redirectUrl, state }) => {
    const searchParams = new URLSearchParams({
        redirect_uri: redirectUrl,
        scope: 'read:user user:email',
        state,
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://github.com/login/oauth/authorize');
    url.search = searchParams.toString();
    return url.toString();
};
const Button$2 = socialLoginStyler(SocialLoginButton)(({ theme }) => ({
    '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(theme.githubButtonStyle))
}));
const GithubLoginButton = () => {
    const onRedirectTo = useOnRedirectTo();
    const { iconsOnly } = useTheme();
    const redirectUrl = useRedirectUrl(createGithubUrl, SocialLoginProviders.Github);
    const handleClick = react.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = React.createElement(SocialLoginCustomComponent, { componentKey: 'githubIcon', className: 'fe-social-login-github-icon' },
        React.createElement(GithubIcon, null));
    if (redirectUrl) {
        return React.createElement(Button$2, { onClick: handleClick, color: 'secondary', startIcon: icon, children: iconsOnly ? undefined : 'Github' });
    }
    return null;
};
var GithubLoginButton$1 = GithubLoginButton;

const codeVerifier = `${v4()}${v4()}`;
const createMicrosoftUrl = ({ clientId, redirectUrl, state }) => {
    localStorage.setItem(FRONTEGG_CODE_VERIFIER, codeVerifier);
    const searchParams = new URLSearchParams({
        response_type: 'code',
        redirect_uri: redirectUrl,
        response_mode: 'query',
        scope: 'openid profile email',
        code_challenge: codeVerifier,
        state,
        code_challenge_type: 'S256',
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://login.microsoftonline.com/common/oauth2/v2.0/authorize');
    url.search = searchParams.toString();
    return url.toString();
};
const Button$1 = socialLoginStyler(SocialLoginButton)(({ theme }) => ({
    '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(theme.microsoftButtonStyle))
}));
const MicrosoftLoginButton = () => {
    const onRedirectTo = useOnRedirectTo();
    const { iconsOnly } = useTheme();
    const redirectUrl = useRedirectUrl(createMicrosoftUrl, SocialLoginProviders.Microsoft);
    const handleClick = react.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = React.createElement(SocialLoginCustomComponent, { componentKey: 'facebookIcon', className: 'fe-social-login-facebook-icon' },
        React.createElement(MicrosoftIcon, null));
    if (redirectUrl) {
        return React.createElement(Button$1, { onClick: handleClick, color: 'secondary', startIcon: icon, children: iconsOnly ? undefined : 'Microsoft' });
    }
    return null;
};
var MicrosoftLoginButton$1 = MicrosoftLoginButton;

const createFacebookUrl = ({ clientId, redirectUrl, state }) => {
    const searchParams = new URLSearchParams({
        scope: 'email',
        redirect_uri: redirectUrl,
        response_type: 'code',
        state,
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://www.facebook.com/v10.0/dialog/oauth');
    url.search = searchParams.toString();
    return url.toString();
};
const Button = socialLoginStyler(SocialLoginButton)(({ theme }) => ({
    '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(theme.facebookButtonStyle))
}));
const FacebookLoginButton = () => {
    const onRedirectTo = useOnRedirectTo();
    const { iconsOnly } = useTheme();
    const redirectUrl = useRedirectUrl(createFacebookUrl, SocialLoginProviders.Facebook);
    const handleClick = react.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = React.createElement(SocialLoginCustomComponent, { componentKey: 'facebookIcon', className: 'fe-social-login-facebook-icon' },
        React.createElement(FacebookIcon, null));
    if (redirectUrl) {
        return React.createElement(Button, { onClick: handleClick, color: 'secondary', startIcon: icon, children: iconsOnly ? undefined : 'Facebook' });
    }
    return null;
};
var FacebookLoginButton$1 = FacebookLoginButton;

const SocialLoginsContainer = socialLoginStyler(Box)(({ theme }) => (Object.assign({ display: 'flex', flexGrow: 1, flexDirection: 'row', marginLeft: '-0.5rem', marginRight: '-0.5rem', justifyContent: 'center', marginTop: '0.5rem' }, theme.containerStyle)));
const SocialLoginsWithWrapper = ({ action, dividerText }) => {
    return (React.createElement(InnerThemeProvider, { themeOptionKey: "socialLogins" },
        React.createElement(SocialLogins, { action: action },
            React.createElement(SocialLoginDivider, { children: dividerText }),
            React.createElement(SocialLoginsContainer, null,
                React.createElement(GoogleLoginButton$1, null),
                React.createElement(GithubLoginButton$1, null),
                React.createElement(MicrosoftLoginButton$1, null),
                React.createElement(FacebookLoginButton$1, null)))));
};
const SocialLoginsLogin = ({ dividerText, withSocialDivider = true }) => {
    return React.createElement(SocialLoginsWithWrapper, { action: SocialLoginsActions.Login, withSocialDivider: withSocialDivider, dividerText: dividerText });
};
const SocialLoginsActivation = ({ dividerText, withSocialDivider = true }) => {
    return React.createElement(SocialLoginsWithWrapper, { action: SocialLoginsActions.Activation, withSocialDivider: withSocialDivider, dividerText: dividerText });
};
const SocialLoginsSignUp = ({ dividerText, withSocialDivider = true }) => {
    return React.createElement(SocialLoginsWithWrapper, { action: SocialLoginsActions.SignUp, withSocialDivider: withSocialDivider, dividerText: dividerText });
};

const Wrapper = styled$3(Box)(({ theme }) => {
    var _a, _b, _c, _d;
    return ({
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        width: (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : '100vw',
        height: '100vh',
        top: 0,
        left: 0,
        marginLeft: (_d = (_c = theme.layout) === null || _c === void 0 ? void 0 : _c.marginLeft) !== null && _d !== void 0 ? _d : '0px',
    });
});
const Container = styled$3(Box) `
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CenterCard = styled$3(Box)(({ theme }) => ({
    overflow: 'auto',
    maxHeight: '90vh',
    maxWidth: '90%',
    boxSizing: 'border-box',
    width: theme.authPage.loginBox.width,
    background: theme.authPage.loginBox.backgroundCard,
    boxShadow: theme.authPage.loginBox.boxShadow,
    borderRadius: theme.authPage.loginBox.borderRadius,
    border: theme.authPage.loginBox.border,
    padding: theme.authPage.loginBox.padding,
}));
// const DEFAULT_IMAGE = 'https://assets.frontegg.com/public-frontegg-assets/logo-transparent.png';
const CompanyLogo = styled$3((props) => {
    const { headerImage } = useShadowDom();
    return React.createElement(Box, Object.assign({ width: "100%" }, props), headerImage ? React.createElement("img", { alt: "logo", src: headerImage }) : React.createElement(CompanyPlaceholder$1, null));
}) `
  & {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 2rem;
    text-align: center;

    img {
      width: 50%;
      margin: auto;
    }
  }
`;
const StyledSuccessIcon = styled$3(SuccessIcon) `
  & {
    width: 100% !important;
    height: 3rem !important;
    color: #2CA744;
    margin-bottom: 2rem;
  }
`;
var AuthActions;
(function (AuthActions) {
    AuthActions["PreLogin"] = "preLogin";
    AuthActions["LoginWithTwoFactor"] = "loginWithTwoFactor";
    AuthActions["LoginWithPassword"] = "loginWithPassword";
    AuthActions["RecoverTwoFactor"] = "recoverTwoFactor";
    AuthActions["RedirectToSSO"] = "redirectToSSO";
    AuthActions["ForceTwoFactor"] = "forceTwoFactor";
    AuthActions["MagicLinkPreLoginSuccess"] = "magicLinkPreLoginSuccess";
    AuthActions["MagicLinkCallback"] = "magicLinkCallback";
    AuthActions["SignUp"] = "signup";
    AuthActions["SignUpSuccess"] = "signupSuccess";
    AuthActions["SignUpFailed"] = "signupFailed";
    AuthActions["LoginWithSSOFailed"] = "loginWithSSOFailed";
    AuthActions["Success"] = "success";
    AuthActions["LoginWithOtc"] = "loginWithOtc";
    AuthActions["AcceptInvitation"] = "acceptInvitation";
    AuthActions["ActivateAccount"] = "activateAccount";
    AuthActions["ForgetPassword"] = "forgetPassword";
    AuthActions["ResetPassword"] = "resetPassword";
})(AuthActions || (AuthActions = {}));
const AuthPage = ({ children, action }) => {
    const { backgroundImage } = useShadowDom();
    const theme = useTheme();
    const headerFallbackComponent = react.exports.useMemo(() => {
        switch (action) {
            case AuthActions.MagicLinkPreLoginSuccess:
                return React.createElement(StyledSuccessIcon, null);
            case AuthActions.MagicLinkCallback:
                return null;
            default:
                return React.createElement(CompanyLogo, { className: 'fe-logo-wrapper' });
        }
    }, [action]);
    return React.createElement(InnerThemeProvider, { themeOptionKey: action !== null && action !== void 0 ? action : 'none', withFallback: true },
        React.createElement(DynamicComponent, { componentKey: `layout.outerCustomBackground` }),
        React.createElement(Wrapper, { key: 'authPage' },
            React.createElement(DynamicComponent, { componentKey: `customTopBar` }),
            React.createElement(Container, { sx: { background: backgroundImage !== null && backgroundImage !== void 0 ? backgroundImage : theme.palette.common.white }, className: 'fe-loginbox-wrapper' },
                React.createElement(CenterCard, { className: 'fe-login-center-card' },
                    React.createElement(DynamicComponent, { componentKey: 'customHeader', fallback: headerFallbackComponent }),
                    children,
                    React.createElement(DynamicComponent, { componentKey: 'footer' })))));
};

const loaderStyler = createStyled();
const CenterContent = loaderStyler(Box)(({ theme }) => {
    return ({
        background: '#FFFFFF',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100000,
    });
});
const getUri$1 = (urlStrategy) => {
    if (urlStrategy === 'path') {
        return (window !== null && window !== void 0 ? window : document).location.pathname;
    }
    else {
        return ((window !== null && window !== void 0 ? window : document).location.hash || '#').substring(1);
    }
};
const PageLoader = () => {
    var _a, _b;
    const { customLoader } = useShadowDom();
    const theme = useTheme();
    const { loginUrl, logoutUrl, activateUrl, acceptInvitationUrl, forgetPasswordUrl, resetPasswordUrl, } = useAuthRoutes();
    const { urlStrategy } = useShadowDom();
    const pathname = getUri$1(urlStrategy);
    react.exports.useEffect(() => {
        document.body.classList.add('frontegg-loading');
        (typeof customLoader === 'function') && (customLoader === null || customLoader === void 0 ? void 0 : customLoader(true));
        return () => {
            document.body.classList.remove('frontegg-loading');
            (typeof customLoader === 'function') && (customLoader === null || customLoader === void 0 ? void 0 : customLoader(false));
        };
    }, [customLoader]);
    const isAuthRoute = react.exports.useMemo(() => {
        const routeValue = [loginUrl, logoutUrl, activateUrl, acceptInvitationUrl, forgetPasswordUrl, resetPasswordUrl];
        return routeValue.includes(pathname);
    }, [pathname, loginUrl,
        logoutUrl,
        activateUrl,
        acceptInvitationUrl,
        forgetPasswordUrl,
        resetPasswordUrl]);
    if (customLoader) {
        return null;
    }
    return React.createElement(CenterContent, { sx: (isAuthRoute ? Object.assign(Object.assign({}, theme.rootStyle), (_a = theme.loader) === null || _a === void 0 ? void 0 : _a.containerStyle) : Object.assign({}, (_b = theme.loader) === null || _b === void 0 ? void 0 : _b.containerStyle)) },
        React.createElement(Loader$1, { "data-test-id": "page-loader" }));
};

const SocialLoginsSuccess = () => {
    const onRedirectTo = useOnRedirectTo();
    const socialLoginsState = useSocialLoginState();
    const { resetSocialLoginsState, setSocialLoginError, loginViaSocialLogin } = useSocialLoginActions();
    const routes = useAuthRoutes();
    const t = useT('socialLogins');
    const redirectUri = useRedirectUri();
    react.exports.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const devCreds = params.get('customised') === 'false';
        const error = t('failedInvalidCallbackUrl');
        const state = params.get('state');
        const code = params.get('code');
        if (!state || !code) {
            setSocialLoginError({ error });
            return;
        }
        let provider;
        if (devCreds) {
            provider = params.get('provider');
        }
        else {
            let parsedState;
            try {
                parsedState = JSON.parse(state);
            }
            catch (e) {
                setSocialLoginError({ error });
                return;
            }
            provider = parsedState.provider;
        }
        if (!provider) {
            setSocialLoginError({ error });
            return;
        }
        const payload = {
            code, provider, state,
        };
        if (!devCreds) {
            payload.redirectUri = redirectUri;
        }
        const codeVerifier = localStorage.getItem(FRONTEGG_CODE_VERIFIER);
        const invitationToken = localStorage.getItem(FRONTEGG_INVITATION_TOKEN);
        localStorage.removeItem(FRONTEGG_CODE_VERIFIER);
        localStorage.removeItem(FRONTEGG_INVITATION_TOKEN);
        if (invitationToken) {
            payload.invitationToken = invitationToken;
        }
        if (codeVerifier) {
            payload.codeVerifier = codeVerifier;
        }
        loginViaSocialLogin(payload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!socialLoginsState.error || socialLoginsState.firstLoad || socialLoginsState.loading) {
        return React.createElement(PageLoader, null);
    }
    return (React.createElement(AuthPage, null,
        React.createElement(Alert$1, { severity: 'error', sx: { mb: 4 } }, socialLoginsState.error),
        React.createElement(Button$1$1, { fullWidth: true, onClick: () => {
                resetSocialLoginsState();
                onRedirectTo(routes.loginUrl);
            } }, t('failedBackToLogin'))));
};

const validateEmail = (invalidMessage, requiredMessage) => create().email(invalidMessage).required(requiredMessage);
const validatePassword = (minLength, invalidMinLengthMessage, requiredMessage) => create().min(minLength, invalidMinLengthMessage).required(requiredMessage);
const validateNotEmpty = (requiredMessage) => {
    create().required(requiredMessage);
};

const TitleComponent = styled$3(UnstyledCustomComponent)(({ theme, componentKey }) => (Object.assign(Object.assign({ fontStyle: 'normal', fontWeight: 'bold', fontSize: '2rem', marginBottom: '2rem', lineHeight: '2.5rem', textAlign: 'center' }, (theme[`boxTitleStyle`])), (theme[`${componentKey}Style`]))));
const BoxTitle = ({ componentKey, title }) => {
    return React.createElement(TitleComponent, { componentKey: componentKey, className: `fe-${componentKey}`, title: title }, title);
};
const MessageComponent = styled$3(UnstyledCustomComponent)(({ theme, componentKey }) => (Object.assign(Object.assign({ fontStyle: 'normal', fontWeight: 400, fontSize: '1rem', marginTop: '0.5rem', marginBottom: '1.5rem', lineHeight: '1.5rem', color: '#7A7D93' }, (theme[`boxMessageStyle`])), (theme[`${componentKey}Style`]))));
const BoxMessage = ({ componentKey, message }) => {
    return React.createElement(MessageComponent, { componentKey: componentKey, className: `fe-${componentKey}`, message: message }, message);
};

const loginStyler = createStyled();
const LoginPageTitle = BoxTitle;
const LoginPageMessage = BoxMessage;
const SignupMessageComponent = CustomComponent;
const ResendOTCComponent = UnstyledCustomComponent;
// export const RecoverMfaTitleComponent: FC<BoxTitleProps> = (props) => <BoxTitle componentKey={'recoverMfaTitle'} {...props}/>;
// export const RecoverMfaTitleComponent: FC<LoginPageTheme['recoverMfaTitle']> = (props) => <TitleComponent componentKey={'recoverMfaTitle'} {...props}/>;
// export const SignupMessageComponent: FC<Omit<CustomComponentType<'signupMessage'>, 'componentKey'>> = (props) =>
//   <CustomComponent componentKey={'signupMessage'} {...props}/>;

const inputStyleKeys = [
    'padding',
    'padding-left',
    'padding-right',
    'padding-top',
    'padding-bottom',
    'margin',
    'margin-left',
    'margin-right',
    'margin-top',
    'margin-bottom',
    'height',
    'background',
    'box-sizing',
    'color',
    'outline',
    'cursor',
    'display',
    'font',
    'letter-spacing',
    'line-height',
    'text-align',
    'text-transform',
    'word-break',
    'word-spacing',
    'writing-mode',
];
const RenderSlottedInput = react.exports.forwardRef((props, ref) => {
    const hiddenInputRef = react.exports.useRef();
    const slottedInputRef = react.exports.useRef();
    const { submitForm } = useFormikContext();
    react.exports.useEffect(() => {
        const interval = setInterval(() => {
            if (hiddenInputRef.current && slottedInputRef.current) {
                const input = slottedInputRef.current;
                const styleLoader = window.getComputedStyle(hiddenInputRef.current);
                for (let i = 0; i < inputStyleKeys.length; i++) {
                    const key = inputStyleKeys[i];
                    const value = styleLoader[key];
                    input.style.setProperty(key, value);
                }
                input.style.setProperty('width', '100%');
                if (input.getAttribute('name') === 'password') {
                    input.style.setProperty('min-width', 'calc(100% + 0.5rem)');
                }
                else {
                    input.style.setProperty('min-width', '100%');
                }
                input.style.setProperty('border', 'none');
                input.style.setProperty('outline', 'none');
                input.style.setProperty('flex', '1');
                input.style.setProperty('opacity', '1');
            }
        }, 50);
        return () => {
            clearInterval(interval);
        };
    }, []);
    const handleSubmit = react.exports.useCallback((e) => {
        e.preventDefault();
        if (e.keyCode === 13 || e.code === 'Enter') {
            e.target.blur();
            submitForm();
        }
    }, [submitForm]);
    return React.createElement(React.Fragment, null,
        React.createElement(Input$1, { inputRef: hiddenInputRef, tabIndex: -1, style: { position: 'fixed', top: -10000, left: -10000, zIndex: -1 } }),
        React.createElement(RenderAsSlot, { name: `slotted-input-${props.name}`, containerStyle: { width: '100%', display: 'flex', flexDirection: 'row' } },
            React.createElement("input", Object.assign({ style: { opacity: 0 }, "data-test-id": `input-${props.name}`, ref: (r) => {
                    slottedInputRef.current = r;
                    ref === null || ref === void 0 ? void 0 : ref(r);
                } }, props, { onKeyUp: handleSubmit }))));
});
const EmailField$2 = ({ shouldBackToLoginIfEmailChanged }) => {
    const t = useT('login');
    const { iframeRendering } = useShadowDom();
    const { submitCount } = useFormikContext();
    const [fieldProps, { error, touched }] = useField('email');
    const { resetForm } = useFormikContext();
    const { setLoginState } = useLoginActions();
    const backToPreLogin = react.exports.useCallback(() => setLoginState({ step: LoginStep.preLogin }), [setLoginState]);
    const onFocus = react.exports.useCallback((event) => {
        if (shouldBackToLoginIfEmailChanged) {
            backToPreLogin();
            resetForm({
                values: {
                    email: fieldProps.value,
                    password: '',
                },
            });
        }
    }, [backToPreLogin, fieldProps, resetForm, shouldBackToLoginIfEmailChanged]);
    return React.createElement(Input$1, Object.assign({ label: t('emailInputLabel') }, fieldProps, { inputComponent: iframeRendering ? undefined : RenderSlottedInput, 
        // onMouseDown={shouldBackToLoginIfEmailChanged ? onFocus : undefined}
        // disabled={shouldBackToLoginIfEmailChanged || submitCount > 0}
        autoFocus: true, onFocus: onFocus, onChange: fieldProps.onChange, error: !!error && touched && (fieldProps.value !== '' || submitCount > 0), placeholder: t('emailInputPlaceholder'), errorMessage: error, autoComplete: "email", "data-test-id": "email-box" }));
};
const InputButton = loginStyler(Link)(({ theme }) => ({
    '&.MuiLink-root': {
        position: 'absolute',
        right: 0,
        color: theme.typography.label.color,
    },
}));
const PasswordField$3 = ({ shouldDisplayPassword, inputRef }) => {
    const t = useT('login');
    const { values } = useFormikContext();
    const [fieldProps, { error, touched }] = useField('password');
    const { setForgotPasswordState } = useForgotPasswordActions();
    const { resetLoginState } = useLoginActions();
    const onRedirectTo = useOnRedirectTo();
    const routes = useAuthRoutes();
    const { iframeRendering } = useShadowDom();
    const onForgetPasswordClick = react.exports.useCallback(() => {
        setForgotPasswordState({ email: values.email });
        resetLoginState();
        onRedirectTo(routes.forgetPasswordUrl);
    }, [setForgotPasswordState, resetLoginState, onRedirectTo, routes]);
    const labelButton = React.createElement(InputButton, { onClick: onForgetPasswordClick, "data-test-id": "forgotPassBtn" }, t('forgotPassword'));
    return React.createElement(React.Fragment, null,
        React.createElement(InputPassword$1, Object.assign({ label: t('passwordInputLabel') }, fieldProps, { inputRef: inputRef, inputComponent: iframeRendering ? undefined : RenderSlottedInput, disabled: false, error: !!error && touched, errorMessage: error, button: labelButton, type: 'password', name: 'password', tabIndex: shouldDisplayPassword ? undefined : -1, autoComplete: "current-password", placeholder: t('passwordInputPlaceholder'), "data-test-id": "password-box" })));
};
const LoginSignupSwitch = loginStyler(Typography)(({ theme }) => (Object.assign({ marginBottom: '0.75rem', textAlign: 'center', color: 'inherit', fontWeight: 'normal' }, theme.signupMessageStyle)));
loginStyler(Typography) `
  &.MuiTypography-root {
    ${themeSelector('authPage.subHeaderMsg', ['color', 'fontFamily', 'fontSize', 'textAlign', 'padding', 'margin', 'textDecoration'])};
  }
`;
const SignUpMessage = () => {
    const t = useT('login');
    const onRedirectTo = useOnRedirectTo();
    const routes = useAuthRoutes();
    const { policy, loading } = useSecurityPolicyState(({ publicPolicy }) => publicPolicy);
    const redirectToSignUp = react.exports.useCallback(() => {
        onRedirectTo(routes.signUpUrl + window.location.search);
    }, [onRedirectTo, routes.signUpUrl]);
    if (loading || !(policy === null || policy === void 0 ? void 0 : policy.allowSignups)) {
        return null;
    }
    const props = {
        goToSignupMessage: t('signUpMessage'),
        goToSignupButtonText: t('signUpLink'),
        goToSignup: redirectToSignUp,
    };
    // TODO: add <JoinTenantIndicator/>
    return React.createElement(SignupMessageComponent, Object.assign({ componentKey: "signupMessage" }, props),
        React.createElement(LoginSignupSwitch, { variant: "subtitle1" },
            props.goToSignupMessage,
            " ",
            React.createElement(Link, { onClick: props.goToSignup, "data-test-id": "redirect-to-signup" }, props.goToSignupButtonText)));
};
const LoginWithPassword = () => {
    const t = useT('login');
    const { isSSOAuth } = useAuth(({ isSSOAuth }) => ({ isSSOAuth }));
    const { loading, step, error } = useLoginState();
    const { login, preLogin, passwordlessPreLogin } = useLoginActions();
    const { publicPolicy: { policy, error: policyError } } = useSecurityPolicyState();
    const { invitationToken } = useVerifyInviteToken();
    const passwordRef = react.exports.useRef(null);
    const recaptchaRef = react.exports.useRef(null);
    const shouldDisplayPassword = react.exports.useMemo(() => (!isSSOAuth || step === LoginStep.loginWithPassword) &&
        (policy === null || policy === void 0 ? void 0 : policy.authStrategy) === AuthStrategyEnum$1.EmailAndPassword, [policy === null || policy === void 0 ? void 0 : policy.authStrategy, isSSOAuth, step]);
    const shouldDisplayOnlySocialLogins = react.exports.useMemo(() => !isSSOAuth && (policy === null || policy === void 0 ? void 0 : policy.authStrategy) === AuthStrategyEnum$1.NoLocalAuthentication, [policy === null || policy === void 0 ? void 0 : policy.authStrategy, isSSOAuth, step]);
    const shouldBackToLoginIfEmailChanged = isSSOAuth && shouldDisplayPassword;
    const validationSchema = {
        email: validateEmail(t('emailMustBeValid'), t('emailIsRequired')),
        password: shouldDisplayPassword ? validatePassword(6, t('passwordMustBeCharacters', { length: 6 }), t('passwordIsRequired')) : undefined,
    };
    react.exports.useEffect(() => {
        var _a, _b;
        if (isSSOAuth && shouldDisplayPassword) {
            (_b = (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }, [shouldDisplayPassword, isSSOAuth]);
    react.exports.useEffect(() => {
        if (recaptchaRef.current && !loading) {
            error && recaptchaRef.current.execute();
        }
    }, [loading, error, recaptchaRef]);
    const initialValues = react.exports.useMemo(() => ({ email: '', password: '', recaptchaToken: '' }), []);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve) => {
            const { email, password, recaptchaToken } = values;
            if (shouldDisplayPassword) {
                login({ email, password, recaptchaToken, invitationToken });
            }
            else if (isSSOAuth) {
                preLogin({ email, recaptchaToken });
            }
            else {
                passwordlessPreLogin({ email, recaptchaToken, type: policy === null || policy === void 0 ? void 0 : policy.authStrategy, invitationToken });
            }
            resolve();
        }),
        initialValues,
        validationSchema: validateSchema(validationSchema),
        enableReinitialize: true,
        validateOnBlur: false,
    };
    const isError = react.exports.useMemo(() => error || policyError, [policyError, error]);
    return React.createElement(React.Fragment, null,
        React.createElement(LoginPageTitle, { componentKey: "title", title: t('title') }),
        React.createElement(SignUpMessage, null),
        !shouldDisplayOnlySocialLogins && (React.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return React.createElement(React.Fragment, null,
                React.createElement(EmailField$2, { shouldBackToLoginIfEmailChanged: shouldBackToLoginIfEmailChanged }),
                React.createElement(Collapse$1, { in: shouldDisplayPassword, appear: false },
                    React.createElement(PasswordField$3, { shouldDisplayPassword: shouldDisplayPassword, inputRef: passwordRef })),
                isError && React.createElement(LoginErrorMessage, null, policyError ? t('missingPolicyErrorMessage') : error),
                React.createElement(Button$1$1, { sx: { mt: 4 }, disabled: loading || !isValid, loading: loading, fullWidth: true, color: "primary", "data-test-id": "submit-btn", type: "submit" }, shouldDisplayPassword ? t('login') : t('continue')),
                React.createElement(ReCaptcha, { recaptchaRef: recaptchaRef, action: "login" }));
        })),
        React.createElement(SocialLoginsLogin, { dividerText: t('signInWithSocialLogin'), withSocialDivider: !shouldDisplayOnlySocialLogins }));
};

const ONE_DAY_IN_SECONDS$1 = 60 * 60 * 24;
const CodeField$1 = () => {
    const t = useT('login');
    const [fieldProps, { error, touched }] = useField('code');
    return React.createElement(Input$1, Object.assign({ label: t('mfaInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, autoComplete: 'one-time-code', "data-test-id": 'mfa-code-input' }));
};
const RememberDeviceField = ({ mfaDeviceExpiration }) => {
    const t = useT('login');
    const [rememberDeviceFieldProps] = useField('rememberDevice');
    return React.createElement(Typography, { variant: "body1" },
        React.createElement(Box, Object.assign({ pl: 0, pb: 4, pt: 4, component: Checkbox }, rememberDeviceFieldProps, { size: "small" })),
        t('mfaRememberThisDevice', { count: Math.floor(mfaDeviceExpiration / ONE_DAY_IN_SECONDS$1) }));
};
const LoginWithTwoFactor = () => {
    const t = useT('login');
    const { loading, error, mfaToken } = useLoginState();
    const { loginWithMfa, setLoginState } = useLoginActions();
    const { allowRememberMfaDevice, mfaDeviceExpiration } = useLoginState();
    const initialValues = react.exports.useMemo(() => ({ code: '', rememberDevice: false }), []);
    const validationSchema = react.exports.useMemo(() => validateSchema({
        code: validateMinLength(6, t('mfaCodeIsRequired'), t('mfaCodeLengthAtLeast6')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ code, rememberDevice }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            loginWithMfa({ mfaToken: mfaToken || '', value: code, rememberDevice, callback });
        }),
        initialValues,
        validationSchema,
    };
    return React.createElement(React.Fragment, null,
        React.createElement(LoginPageTitle, { componentKey: 'title', title: t('mfaTitle') }),
        React.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return React.createElement(React.Fragment, null,
                React.createElement(CodeField$1, null),
                error && React.createElement(LoginErrorMessage, null, error),
                allowRememberMfaDevice && mfaDeviceExpiration && React.createElement(RememberDeviceField, { mfaDeviceExpiration: mfaDeviceExpiration }),
                React.createElement(Box, { height: '1px', mb: 4 }),
                React.createElement(Button$1$1, { className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: 'primary', loading: loading, "data-test-id": 'submit-btn' }, t('login')),
                React.createElement(Typography, { variant: 'body1Bold', mt: 4 }, t('disableMultiFactorTitle')),
                React.createElement(Typography, { variant: 'body1', mt: 1 },
                    React.createElement(Link, { "data-test-id": "disableMfaClickHereButton", onClick: () => {
                            setLoginState({ step: LoginStep.recoverTwoFactor });
                        } }, t('disabledMultiFactorClickHereButton')),
                    " ",
                    t('disableMultiFactorMessage')),
                React.createElement(ReCaptcha, { action: 'login' }));
        }));
};

const CodeField = () => {
    const t = useT('login');
    const [fieldProps, { error, touched }] = useField('code');
    return React.createElement(Input$1, Object.assign({ label: t('enterRecoveryCode') }, fieldProps, { error: !!error && touched, errorMessage: error, autoComplete: 'one-time-code', "data-test-id": 'mfa-code-input' }));
};
const RecoverTwoFactor = () => {
    const t = useT('login');
    const { recoverMfa } = useLoginActions();
    const { loading, error, email } = useLoginState();
    const initialValues = react.exports.useMemo(() => ({ code: '' }), []);
    const validationSchema = react.exports.useMemo(() => validateSchema({
        code: validateMinLength(8, t('twoFactorCodeIsRequired'), t('twoFactorCodeLengthAtLeast8')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ code }) => new Promise((resolve) => {
            recoverMfa({ email: email !== null && email !== void 0 ? email : '', recoveryCode: code });
            resolve();
        }),
        initialValues,
        validationSchema,
    };
    return React.createElement(React.Fragment, null,
        React.createElement(LoginPageTitle, { componentKey: 'recoverMfaTitle', title: t('recoverMfaTitle') }),
        React.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return React.createElement(React.Fragment, null,
                React.createElement(CodeField, null),
                error && React.createElement(LoginErrorMessage, null, error),
                React.createElement(Button$1$1, { sx: { mt: 4 }, "data-test-id": 'diableMfaBtn', className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: 'primary', loading: loading }, t('disabledMultiFactorButton')),
                React.createElement(ReCaptcha, { action: 'login' }));
        }));
};

const LargeLoader = ({ height }) => {
    return React.createElement(Grid, { container: true, justifyContent: 'center', alignItems: 'center', height: height !== null && height !== void 0 ? height : 100 },
        React.createElement(Grid, { item: true },
            React.createElement(Loader$1, { "data-test-id": "page-loader" })));
};

const RedirectToSSO = () => {
    const t = useT('login');
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { sx: { marginBottom: 4, width: '100%', textAlign: 'center' }, variant: 'body1Bold' }, t('ssoRedirectToMessage')),
        React.createElement(LargeLoader, { height: 40 })));
};

const MFARecoveryCodeStepForm = () => {
    const t = useT('recoveryMfa');
    const { recoveryCode } = useMfaState(({ recoveryCode }) => ({ recoveryCode }));
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mb: 4 },
            React.createElement(InputCopy$1, { label: t('recoveryCodeLabel'), value: recoveryCode })),
        React.createElement(Box, { mb: 4 },
            React.createElement(Alert$1, { color: "warning" },
                React.createElement(Typography, { variant: "subtitle2" }, t('copyAndSaveCode'))))));
};
const MFARecoveryCodeStep = () => {
    const t = useT('recoveryMfa');
    const { step } = useMfaState(({ step }) => ({ step }));
    const { setState } = useAuthActions();
    const onRedirectTo = useOnRedirectTo();
    const routes = useAuthRoutes();
    const handleContinue = react.exports.useCallback(() => {
        setState({ isAuthenticated: true });
        const { loginUrl, logoutUrl, socialLoginCallbackUrl, activateUrl } = routes;
        let authenticatedUrl = routes.authenticatedUrl;
        const afterAuthRedirect = window.localStorage.getItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
        if (afterAuthRedirect && ![loginUrl, logoutUrl, socialLoginCallbackUrl, activateUrl].includes(afterAuthRedirect)) {
            authenticatedUrl = afterAuthRedirect;
        }
        window.localStorage.removeItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
        const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
        const redirectUrl = url.searchParams.get('redirectUrl') || authenticatedUrl;
        onRedirectTo(redirectUrl, { refresh: redirectUrl.startsWith('http') });
    }, [setState, onRedirectTo, routes]);
    if (step !== MFAStep$1.recoveryCode) {
        return null;
    }
    return (React.createElement(AuthPage, null,
        React.createElement(Typography, { variant: "subtitle1", mb: 2 }, t('title')),
        React.createElement(MFARecoveryCodeStepForm, null),
        React.createElement(Box, { textAlign: 'right' },
            React.createElement(Button$1$1, { "data-test-id": "continueBtn", className: 'fe-primary-btn', color: "primary", onClick: handleContinue }, t('continueButton')))));
};

const ONE_DAY_IN_SECONDS = 60 * 60 * 24;
var MFAStep;
(function (MFAStep) {
    MFAStep["verify"] = "verify";
    MFAStep["recoveryCode"] = "recoveryCode";
})(MFAStep || (MFAStep = {}));
const GoogleAuthenticatorLink = react.exports.memo(() => {
    return (React.createElement(Link, { href: "https://www.google.com/search?q=google+authenticator", target: "_blank" }, "Google Authenticator"));
});
const MFAVerifyStepForm = () => {
    const t = useT('login');
    const { loading, qrCode, error: stateError } = useMfaState();
    const { enrollMfa } = useMfaActions();
    const [tokenFieldProps, { error: tokenError }] = useField('token');
    const [rememberDeviceFieldProps] = useField('rememberDevice');
    const { allowRememberMfaDevice, mfaDeviceExpiration } = useLoginState();
    react.exports.useEffect(() => {
        if (!qrCode) {
            enrollMfa();
        }
    }, [qrCode, enrollMfa]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "body1" },
            t('forceMfaScanQueryDescription1'),
            " ",
            React.createElement(GoogleAuthenticatorLink, null),
            " ",
            t('forceMfaScanQueryDescription2')),
        React.createElement(Box, { margin: "2rem auto", textAlign: 'center' }, loading && !qrCode ? React.createElement(Loader$1, { center: true }) : React.createElement("img", { alt: "Multi-factor QR", src: qrCode !== null && qrCode !== void 0 ? qrCode : '' })),
        React.createElement(Input$1, Object.assign({ "data-test-id": "6DigitsBox" }, tokenFieldProps, { autoFocus: true, inputMode: "numeric", label: t('mfaInputLabel'), error: !!tokenError || !!stateError, errorMessage: tokenError || stateError, autoComplete: "one-time-code", placeholder: t('forceMfaInputPlaceholder') })),
        allowRememberMfaDevice && mfaDeviceExpiration && React.createElement(Typography, { variant: "body1" },
            React.createElement(Box, Object.assign({ "data-test-id": "forceMfaRememberThisDevice", pl: 0, pb: 4, pt: 4, component: Checkbox }, rememberDeviceFieldProps, { size: "small" })),
            t('forceMfaRememberThisDevice', { count: Math.floor(mfaDeviceExpiration / ONE_DAY_IN_SECONDS) }))));
};
const ForceEnrollMfa = () => {
    const t = useT('login');
    const { step, loading, recoveryCode, mfaToken } = useMfaState();
    const { setMfaState, verifyMfaAfterForce } = useMfaActions();
    const recoveryCodeRef = react.exports.useRef('');
    react.exports.useEffect(() => {
        recoveryCodeRef.current = recoveryCode !== null && recoveryCode !== void 0 ? recoveryCode : '';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (step === MFAStep.recoveryCode) {
        return React.createElement(MFARecoveryCodeStep, null);
    }
    return (React.createElement(AuthPage, null,
        React.createElement(FromWrapper, { validationSchema: validateSchema({
                token: validateTwoFactorCode(t, 'token'),
            }), initialValues: { token: '', rememberDevice: false }, onSubmit: ({ token, rememberDevice }, { setSubmitting }) => __awaiter(void 0, void 0, void 0, function* () {
                verifyMfaAfterForce({
                    mfaToken: mfaToken || '',
                    value: token,
                    rememberDevice,
                    callback: (success) => {
                        if (success) {
                            setMfaState({ recoveryCode });
                        }
                        setSubmitting(false);
                    },
                });
            }) }, ({ isValid }) => {
            return (React.createElement(Box, null,
                React.createElement(Typography, { variant: "subtitle1", mb: 4 }, t('forceMfaMessage')),
                React.createElement(MFAVerifyStepForm, null),
                React.createElement(Box, { className: "fe-dialog__footer" },
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { xs: true, item: true, className: "fe-text-align-end" },
                            React.createElement(Button$1$1, { className: 'fe-primary-btn', disabled: !isValid, type: "submit", size: "large", fullWidth: true, color: "primary", loading: loading, "data-test-id": "sumbit-btn" }, t('forceMfaVerifyButton')))))));
        })));
};

const PasswordlessPreLoginSuccessContainer = styled$3(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '.MuiTypography-root': {
        marginBottom: '1.5rem',
    },
});
const MagicLinkPreLoginSuccess = () => {
    const t = useT('login');
    const { email, loading } = useLoginState();
    const { passwordlessPreLogin, resetLoginState } = useLoginActions();
    const recaptchaRef = React.createRef();
    const { invitationToken } = useVerifyInviteToken();
    react.exports.useEffect(() => {
        if (recaptchaRef.current && !loading) {
            recaptchaRef.current.execute();
        }
    }, [loading, recaptchaRef]);
    return React.createElement(React.Fragment, null,
        React.createElement(LoginPageTitle, { componentKey: 'magicLinkTitle', title: t('magicLinkTitle') }),
        React.createElement(LoginPageMessage, { componentKey: 'magicLinkMessage', message: t(`magicLinkText`, { email }) }),
        React.createElement(FromWrapper, { initialValues: { email, recaptchaToken: '' }, onSubmit: (values) => passwordlessPreLogin(Object.assign(Object.assign({}, values), { invitationToken, type: AuthStrategyEnum.MagicLink })) }, () => React.createElement(PasswordlessPreLoginSuccessContainer, null,
            React.createElement(Button$1$1, { fullWidth: true, color: 'primary', loading: loading, "data-test-id": 'passwordless-prelogin-success-resend-btn' }, t(`magicLinkResend`)),
            React.createElement(Link, { sx: { mt: 4 }, onClick: resetLoginState }, t(`backToLogin`)),
            React.createElement(ReCaptcha, { recaptchaRef: recaptchaRef, action: 'passwordless_prelogin' }))));
};

const ResendContainer = loginStyler(ResendOTCComponent)(({ theme }) => (Object.assign({ marginTop: '1rem', textAlign: 'center' }, theme.resendOTCStyle)));
const ResendOTCMessage = loginStyler(Typography)(({ theme }) => (Object.assign({ color: 'inherit' }, theme.resendOTCMessageStyle)));
const OTCField = () => {
    const [fieldProps, { error, touched }] = useField('token');
    const t = useT('login');
    return (React.createElement(Box, { sx: { mb: 4 } },
        React.createElement(Input$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, name: 'token', label: t('otcInputLabel'), placeholder: t('otcInputPlaceholder'), "data-test-id": 'otc-box' }))));
};
const ResendCode = () => {
    const t = useT('login');
    const { passwordlessPreLogin, resetLoginState } = useLoginActions();
    const { email } = useLoginState();
    const { values: { recaptchaToken } } = useFormikContext();
    const resendOTC = react.exports.useCallback(() => {
        if (email) {
            passwordlessPreLogin({ recaptchaToken, type: AuthStrategyEnum.Code, email: email });
        }
        else {
            resetLoginState();
        }
    }, [email, recaptchaToken]);
    const props = {
        haventReceiveOTCMessage: t('otcHaventReceivedCode'),
        resendOTCMessage: t('otcResend'),
        resendOTC,
    };
    return React.createElement(ResendContainer, Object.assign({ componentKey: 'resendOTC' }, props),
        React.createElement(ResendOTCMessage, { variant: 'subtitle1' },
            props.haventReceiveOTCMessage,
            " ",
            React.createElement(Link, { onClick: props.resendOTC, "data-test-id": 'resend-otc-btn' }, props.resendOTCMessage)));
};
const LoginWithOTC = () => {
    const t = useT('login');
    const { email, loading, error } = useLoginState();
    const { passwordlessPostLogin } = useLoginActions();
    const recaptchaRef = React.createRef();
    const { invitationToken } = useVerifyInviteToken();
    react.exports.useEffect(() => {
        if (recaptchaRef.current && !loading) {
            recaptchaRef.current.execute();
        }
    }, [loading, recaptchaRef]);
    return React.createElement(React.Fragment, null,
        React.createElement(LoginPageTitle, { componentKey: 'otcTitle', title: t('otcTitle') }),
        React.createElement(LoginPageMessage, { componentKey: 'otcMessage', message: t(`otcMessage`, { email }) }),
        React.createElement(FromWrapper, { initialValues: { token: '', recaptchaToken: '' }, onSubmit: (values) => passwordlessPostLogin(Object.assign(Object.assign({}, values), { invitationToken, type: AuthStrategyEnum.Code })), validationSchema: validateSchema({
                token: validateNotEmpty(t('otcCodeIsRequired')),
            }) }, ({ values, isValid }) => React.createElement(React.Fragment, null,
            React.createElement(ReCaptcha, { recaptchaRef: recaptchaRef, action: 'passwordless_prelogin' }),
            React.createElement(OTCField, null),
            error && React.createElement(LoginErrorMessage, null, error),
            React.createElement(Button$1$1, { disabled: loading || !isValid, className: 'fe-primary-btn', fullWidth: true, color: 'primary', loading: loading, "data-test-id": 'passwordless-prelogin-success-resend-btn' }, t('otcContinue')),
            React.createElement(ResendCode, null))));
};

const loginStepToAuthAction = {
    [LoginStep.preLogin]: AuthActions.PreLogin,
    [LoginStep.loginWithPassword]: AuthActions.LoginWithPassword,
    [LoginStep.loginWithTwoFactor]: AuthActions.LoginWithTwoFactor,
    [LoginStep.recoverTwoFactor]: AuthActions.RecoverTwoFactor,
    [LoginStep.redirectToSSO]: AuthActions.RedirectToSSO,
    [LoginStep.forceTwoFactor]: AuthActions.ForceTwoFactor,
    [LoginStep.magicLinkPreLoginSuccess]: AuthActions.MagicLinkPreLoginSuccess,
    [LoginStep.loginWithSSOFailed]: AuthActions.LoginWithSSOFailed,
    [LoginStep.loginWithOtc]: AuthActions.LoginWithOtc,
    [LoginStep.success]: AuthActions.Success,
};

const TenantInvitationFailed = ({ t, variant }) => {
    const { resetLoginState } = useAuthActions();
    const routes = useAuthRoutes();
    const { inviteTokenError } = useLoginState(({ inviteTokenError }) => ({ inviteTokenError }));
    const onRedirectTo = useOnRedirectTo();
    const backPath = react.exports.useMemo(() => variant === 'signup' ? routes.signUpUrl : routes.loginUrl, [variant]);
    return React.createElement(React.Fragment, null,
        React.createElement(Alert$1, { className: 'fe-alert-error', severity: 'error' },
            React.createElement(Typography, { color: 'error', variant: 'subtitle1' }, t('failedJoinTenantTitle')),
            React.createElement(Typography, { color: 'error', variant: 'subtitle2' }, inviteTokenError)),
        React.createElement(Box, { height: '1px', mb: 4 }),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                React.createElement(Button$1$1, { "data-test-id": 'back-to-login-btn', className: 'fe-back-to-login-btn', fullWidth: true, onClick: () => {
                        resetLoginState();
                        onRedirectTo(backPath, { preserveQueryParams: false });
                    } }, t('failedJoinTenantBackButton')))));
};

const LoginContainer = loginStyler(Box)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const LoginPage$1 = () => {
    const t = useT('login');
    const { isLoading, isAuthenticated } = useAuth(({ isLoading, isAuthenticated }) => ({ isLoading, isAuthenticated }));
    const { step, inviteTokenError } = useLoginState(({ step, inviteTokenError }) => ({ step, inviteTokenError }));
    const { authOptions: { includeQueryParam } = {} } = useShadowDom();
    const onRedirectTo = useOnRedirectTo();
    const routes = useAuthRoutes();
    react.exports.useEffect(() => {
        // only after first mount and redirected by saga
        const timeout = setTimeout(() => {
            var _a;
            if (!isLoading && isAuthenticated && window.location.pathname.endsWith(routes.loginUrl)) {
                const url = new URL(window.location.href);
                let redirectUrl = routes.authenticatedUrl;
                if (url.searchParams.get('redirectUrl')) {
                    redirectUrl = (_a = url.searchParams.get('redirectUrl')) !== null && _a !== void 0 ? _a : routes.authenticatedUrl;
                }
                else if (includeQueryParam) {
                    redirectUrl += window.location.search;
                }
                onRedirectTo(redirectUrl, { refresh: redirectUrl.startsWith('http') });
            }
        }, 1000);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { action, components } = react.exports.useMemo(() => {
        let components = null;
        if (inviteTokenError) {
            components = React.createElement(TenantInvitationFailed, { variant: 'login', t: t });
        }
        else if (step === LoginStep.preLogin || step === LoginStep.loginWithPassword) {
            components = React.createElement(LoginWithPassword, null);
        }
        else if (step === LoginStep.loginWithTwoFactor) {
            components = React.createElement(LoginWithTwoFactor, null);
        }
        else if (step === LoginStep.recoverTwoFactor) {
            components = React.createElement(RecoverTwoFactor, null);
        }
        else if (step === LoginStep.redirectToSSO) {
            components = React.createElement(RedirectToSSO, null);
        }
        else if (step === LoginStep.forceTwoFactor) {
            components = React.createElement(ForceEnrollMfa, null);
        }
        else if (step === LoginStep.magicLinkPreLoginSuccess) {
            components = React.createElement(MagicLinkPreLoginSuccess, null);
        }
        else if (step === LoginStep.loginWithOtc) {
            components = React.createElement(LoginWithOTC, null);
        }
        return { action: loginStepToAuthAction[step], components };
    }, [step, inviteTokenError]);
    if (isLoading || isAuthenticated) {
        return React.createElement(PageLoader, null);
    }
    return (React.createElement(LoginContainer, null, components));
};

const LoginPage = wrapPage(LoginPage$1, 'login');

const acceptInvitationStyler = createStyled();

const AcceptInvitationSuccessContainer = acceptInvitationStyler(Box)(({ theme }) => (Object.assign({}, theme.successContainerStyle)));
const AcceptInvitationSuccess = () => {
    const t = useT('acceptInvitation');
    const { loginUrl } = useAuthRoutes();
    const onRedirectTo = useOnRedirectTo();
    react.exports.useEffect(() => {
        setTimeout(() => {
            onRedirectTo(loginUrl);
        }, 3000);
    }, [loginUrl, onRedirectTo]);
    return (React.createElement(AcceptInvitationSuccessContainer, null,
        React.createElement(Alert$1, { severity: 'success' },
            React.createElement(Typography, { variant: 'subtitle1' }, t('successTitle')))));
};

const AcceptInvitationFailedContainer = acceptInvitationStyler(Box)(({ theme }) => (Object.assign({}, theme.failedContainerStyle)));
const AcceptInvitationFailed = ({ isInvalid }) => {
    const t = useT('acceptInvitation');
    const onRedirectTo = useOnRedirectTo();
    const { loginUrl } = useAuthRoutes();
    const backToLogin = react.exports.useCallback(() => onRedirectTo(loginUrl), [loginUrl]);
    return (React.createElement(AcceptInvitationFailedContainer, null,
        React.createElement(Alert$1, { severity: 'error', sx: { marginBottom: 4 } },
            React.createElement(Typography, { variant: 'subtitle1' }, t(isInvalid ? 'invalidTitle' : 'failedTitle')),
            React.createElement(Typography, { variant: 'body1' }, t(isInvalid ? 'invalidMessage' : 'failedMessage'))),
        React.createElement(Button$1$1, { className: 'fe-back-to-login-btn', "data-test-id": 'loginBack-btn', fullWidth: true, onClick: backToLogin }, t(isInvalid ? 'invalidBackToLoginButton' : 'failedBackToLoginButton'))));
};
const AcceptInvitationInvalid = () => React.createElement(AcceptInvitationFailed, { isInvalid: true });

const AcceptInvitationContainer = acceptInvitationStyler(Box)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const AcceptInvitationPage$1 = () => {
    const { acceptInvitation } = useAcceptInvitationActions();
    const { step } = useAcceptInvitationState();
    const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    const userId = url.searchParams.get('userId') || '';
    const token = url.searchParams.get('token') || '';
    react.exports.useEffect(() => {
        acceptInvitation({ token, userId });
    }, [acceptInvitation, token, userId]);
    let components = null;
    switch (step) {
        case AcceptInvitationStep.invalid:
            components = React.createElement(AcceptInvitationInvalid, null);
            break;
        case AcceptInvitationStep.pending:
            components = React.createElement(LargeLoader, null);
            break;
        case AcceptInvitationStep.success:
            components = React.createElement(AcceptInvitationSuccess, null);
            break;
        case AcceptInvitationStep.failed:
            components = React.createElement(AcceptInvitationFailed, null);
            break;
        default:
            return null;
    }
    return React.createElement(AcceptInvitationContainer, null, components);
};

const AcceptInvitationPage = wrapPage(AcceptInvitationPage$1, 'acceptInvitation');

const activateAccountStyler = createStyled();
const ActivateAccountPageTitle = BoxTitle;

const ActivateAccountFormContainer = activateAccountStyler(Box)(({ theme }) => (Object.assign({}, theme.formContainerStyle)));
const PasswordField$2 = () => {
    const t = useT('activateAccount');
    const [fieldProps, { error, touched }] = useField('password');
    return React.createElement(InputPassword$1, Object.assign({}, fieldProps, { error: !!error && touched, type: "password", name: "password", label: t('newPasswordInputLabel'), placeholder: t('newPasswordInputPlaceholder'), "data-test-id": "password-box" }));
};
const ConfirmPasswordField$1 = () => {
    const t = useT('activateAccount');
    const [fieldProps, { error, touched }] = useField('confirmPassword');
    return React.createElement(InputPassword$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, type: "password", name: "confirmPassword", label: t('confirmPasswordInputLabel'), placeholder: t('confirmPasswordInputPlaceholder'), "data-test-id": "confirmPassword-box" }));
};
const PasswordStrength$1 = (props) => {
    const [{ value }] = useField('password');
    const t = useGlobalT();
    return React.createElement(PasswordStrengthChecker, Object.assign({ t: t, value: value, isTouched: value !== '' }, props));
};
const ActivateAccountForm = (props) => {
    var _a;
    const { userId, token } = props;
    const t = useT('activateAccount');
    const { isAuthenticated } = useAuth();
    const [logoutLoader, setLogoutLoader] = react.exports.useState(isAuthenticated);
    const { activateAccount, silentLogout, getActivateAccountStrategy } = useAuthActions();
    const { loading: activateStateLoading, error, activationStrategy } = useActivateAccountState();
    const { loading: passwordConfigLoading, passwordConfig } = usePasswordConfig(props.userId);
    const { captchaPolicy } = useSecurityPolicyState();
    const recaptcha = useRecaptcha({ action: 'activate_account' });
    react.exports.useEffect(() => {
        var _a, _b;
        const captchaLoading = captchaPolicy.loading && (!((_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled) || (recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token.length));
        if (!activationStrategy.loading && !((_b = activationStrategy.strategy) === null || _b === void 0 ? void 0 : _b.shouldSetPassword) && !captchaLoading) {
            activateAccount({ userId, token, recaptchaToken: recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token });
        }
    }, [activateAccount, activationStrategy, captchaPolicy, recaptcha]);
    react.exports.useEffect(() => {
        const logoutCallback = () => {
            setLogoutLoader(false);
            getActivateAccountStrategy({ userId, token });
        };
        silentLogout(logoutCallback);
    }, [silentLogout, getActivateAccountStrategy, userId, token]);
    const initialValues = react.exports.useMemo(() => ({ password: '', confirmPassword: '', token, userId, recaptchaToken: '' }), [token, userId]);
    const validationSchema = react.exports.useMemo(() => validateSchema({
        password: validatePasswordUsingOWASP(t('newPasswordIsRequired')),
        confirmPassword: validateConfirmPassword(t('confirmPasswordIsRequired'), t('confirmPasswordMustMatch')),
    }), [passwordConfig, t]);
    const formikProps = {
        onSubmit: ({ password }) => new Promise((resolve, reject) => {
            activateAccount({ password, token, userId, recaptchaToken: recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token });
            resolve();
        }),
        initialValues,
        validationSchema,
    };
    const loading = logoutLoader ||
        activationStrategy.loading ||
        passwordConfigLoading ||
        (!((_a = activationStrategy.strategy) === null || _a === void 0 ? void 0 : _a.shouldSetPassword) && activateStateLoading);
    console.log({
        logoutLoader,
        activationStrategy,
        passwordConfigLoading,
        activateStateLoading,
    });
    if (loading) {
        return React.createElement(React.Fragment, null,
            " ", recaptcha === null || recaptcha === void 0 ? void 0 :
            recaptcha.component,
            " ",
            React.createElement(PageLoader, null));
    }
    return React.createElement(ActivateAccountFormContainer, null,
        React.createElement(ActivateAccountPageTitle, { componentKey: "title", title: t('title') }),
        React.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return React.createElement(React.Fragment, null,
                React.createElement(PasswordField$2, null),
                React.createElement(PasswordStrength$1, { passwordConfig: passwordConfig, loading: loading || !passwordConfig }),
                React.createElement(ConfirmPasswordField$1, null),
                error && React.createElement(LoginErrorMessage, null, error),
                React.createElement(Button$1$1, { sx: { mt: 4 }, className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: "primary", loading: activateStateLoading, "data-test-id": "activate-btn" }, t('activateButton')), recaptcha === null || recaptcha === void 0 ? void 0 :
                recaptcha.component);
        }),
        React.createElement(SocialLoginsActivation, { dividerText: 'Or Activate Uith' }));
};

const ActivateAccountSuccessContainer = activateAccountStyler(Box)(({ theme }) => (Object.assign({}, theme.successContainerStyle)));
const ActivateAccountSuccess = () => {
    const t = useT('activateAccount');
    const { requestAuthorize, resetActivateState } = useAuthActions();
    const theme = useTheme();
    react.exports.useEffect(() => {
        requestAuthorize(true);
        return resetActivateState;
    }, [resetActivateState, requestAuthorize]);
    return (React.createElement(ActivateAccountSuccessContainer, null,
        React.createElement(Alert$1, { className: 'fe-alert-success', severity: 'success', sx: { marginBottom: theme.spacing(4) } }, t('successTitle')),
        React.createElement(Grid, { container: true, justifyContent: 'center', alignItems: 'center', height: 40 },
            React.createElement(Grid, { item: true },
                React.createElement(Loader$1, null)))));
};

const ActivateAccountFailedContainer = activateAccountStyler(Box)(({ theme }) => (Object.assign({}, theme.failedContainerStyle)));
const ActivateAccountFailed = ({ title, description }) => {
    const t = useT('activateAccount');
    const { resetActivateState, resetLoginState, resetMfaState } = useAuthActions();
    const routes = useAuthRoutes();
    const onRedirectTo = useOnRedirectTo();
    return (React.createElement(ActivateAccountFailedContainer, null,
        React.createElement(Alert$1, { className: 'fe-alert-error', severity: 'error', sx: { marginBottom: 4 } },
            React.createElement(Typography, { color: 'error', variant: 'subtitle1' }, t(title)),
            React.createElement(Typography, { color: 'error', variant: 'subtitle2' }, t(description))),
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                React.createElement(Button$1$1, { className: 'fe-back-to-login-btn', fullWidth: true, onClick: () => {
                        resetActivateState();
                        resetLoginState();
                        resetMfaState();
                        onRedirectTo(routes.loginUrl);
                    } }, t('failedBackToLoginButton'))))));
};

const ActivateAccountContainer = activateAccountStyler(Box)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const ActivateAccountPage$1 = () => {
    const { isLoading, isAuthenticated } = useAuth(({ isLoading, isAuthenticated }) => ({ isLoading, isAuthenticated }));
    const { step, activationStrategy } = useActivateAccountState();
    const { builderMode } = useShadowDom();
    const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    const userId = url.searchParams.get('userId') || (builderMode ? 'demo-user-id' : '');
    const token = url.searchParams.get('token') || (builderMode ? 'demo-token-id' : '');
    let components;
    if (isLoading || isAuthenticated) {
        return React.createElement(PageLoader, null);
    }
    else if (!userId || !token) {
        components = React.createElement(ActivateAccountFailed, { title: 'linkFailedTitle', description: 'linkFailedMessage' });
    }
    else if (!!(activationStrategy === null || activationStrategy === void 0 ? void 0 : activationStrategy.error)) {
        components = React.createElement(ActivateAccountFailed, { title: 'linkExpiredTitle', description: 'linkExpiredMessage' });
    }
    else if (step === ActivateAccountStep.success) {
        components = React.createElement(ActivateAccountSuccess, null);
    }
    else if (step === ActivateAccountStep.activating) {
        components = React.createElement(ActivateAccountForm, { userId: userId, token: token });
    }
    return React.createElement(ActivateAccountContainer, null, components);
};

const ActivateAccountPage = wrapPage(ActivateAccountPage$1, 'activateAccount');

const forgotPasswordStyler = createStyled();
const ForgotPasswordPageTitle = BoxTitle;
const ForgotPasswordPageMessage = BoxMessage;

const ForgotPasswordFormContainer = forgotPasswordStyler(Box)(({ theme }) => (Object.assign({}, theme.formContainerStyle)));
const EmailField$1 = () => {
    const t = useT('forgetPassword');
    const [fieldProps, { error, touched }] = useField('email');
    return React.createElement(Input$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, name: "email", placeholder: t('emailInputPlaceholder'), label: t('emailInputLabel'), "data-test-id": "email-box" }));
};
const ForgotPasswordForm = () => {
    const t = useT('forgetPassword');
    const { loading, email = '', error } = useForgotPasswordState();
    const { forgotPassword } = useForgotPasswordActions();
    const onRedirectTo = useOnRedirectTo();
    const { loginUrl } = useAuthRoutes();
    const handleBackToLogin = react.exports.useCallback(() => {
        onRedirectTo(loginUrl);
    }, [loginUrl, onRedirectTo]);
    const initialValues = react.exports.useMemo(() => ({ email }), [email]);
    const validationSchema = react.exports.useMemo(() => validateSchema({
        email: validateEmail$1(t('emailMustBeValid'), t('emailIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ email }) => new Promise((resolve) => {
            forgotPassword({ email });
            resolve();
        }),
        initialValues,
        validationSchema,
    };
    return React.createElement(ForgotPasswordFormContainer, null,
        React.createElement(ForgotPasswordPageTitle, { componentKey: "title", title: t('title') }),
        React.createElement(ForgotPasswordPageMessage, { componentKey: "message", message: t('description') }),
        React.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return React.createElement(React.Fragment, null,
                React.createElement(EmailField$1, null),
                React.createElement(Box, { height: "1px", mb: 4 }),
                error && React.createElement(LoginErrorMessage, null, error),
                React.createElement(Button$1$1, { className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: "primary", loading: loading, "data-test-id": "submit-btn" }, t('submitButtonText')),
                React.createElement(Box, { height: "1px", mb: 4 }),
                React.createElement(Box, { textAlign: "center" },
                    React.createElement(Button$1$1, { variant: "text", color: "inherit", size: "small", type: "reset", "data-test-id": "back-to-login-btn", onClick: handleBackToLogin }, t('backToLogin'))));
        }));
};

const ForgotPasswordSuccessContainer = forgotPasswordStyler(Box)(({ theme }) => (Object.assign({}, theme.successContainerStyle)));
const ForgotPasswordSuccess = () => {
    const t = useT('forgetPassword');
    const onRedirectTo = useOnRedirectTo();
    const { loginUrl } = useAuthRoutes();
    const { resetForgotPasswordState } = useForgotPasswordActions();
    return (React.createElement(ForgotPasswordSuccessContainer, null,
        React.createElement(Alert$1, { className: 'fe-alert-success', severity: 'success', sx: { mb: 4 } }, t('resetEmailSentMessage')),
        React.createElement(Button$1$1, { "data-test-id": 'back-to-login-btn', className: 'fe-back-to-login-btn', fullWidth: true, onClick: () => {
                resetForgotPasswordState();
                onRedirectTo(loginUrl);
            } }, t('backToLogin'))));
};

const ForgotPasswordContainer = forgotPasswordStyler(Box)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const ForgotPasswordPage$1 = () => {
    const { step } = useForgotPasswordState();
    let components;
    if (step === ForgotPasswordStep.success) {
        components = React.createElement(ForgotPasswordSuccess, null);
    }
    else {
        components = React.createElement(ForgotPasswordForm, null);
    }
    return React.createElement(ForgotPasswordContainer, null, components);
};

const ForgotPasswordPage = wrapPage(ForgotPasswordPage$1, 'forgotPassword');

const ResetPasswordFailed = () => {
    const t = useT('resetPassword');
    const theme = useTheme();
    const { loginUrl, onRedirectTo, resetForgotPasswordState } = useAuth();
    return (React.createElement(React.Fragment, null,
        React.createElement(Alert$1, { className: 'fe-alert-error', severity: 'error', sx: { marginBottom: theme.spacing(4) } },
            React.createElement(Typography, { color: 'error', variant: 'subtitle1' }, t('failedTitle')),
            React.createElement(Typography, { color: 'error', variant: 'subtitle2' }, t('failedMessage'))),
        React.createElement(Button$1$1, { className: 'fe-back-to-login-btn', "data-test-id": 'loginBack-btn', fullWidth: true, onClick: () => {
                resetForgotPasswordState();
                onRedirectTo(loginUrl);
            } }, t('failedBackToLoginButton'))));
};

const ResetPasswordSuccess = (props) => {
    const t = useT('resetPassword');
    const theme = useTheme();
    const { resetForgotPasswordState } = useAuth();
    const routes = useAuthRoutes();
    const onRedirectTo = useOnRedirectTo();
    react.exports.useEffect(() => {
        setTimeout(() => {
            onRedirectTo(routes.loginUrl);
        }, 1000);
        return resetForgotPasswordState;
    }, [onRedirectTo, resetForgotPasswordState, routes.loginUrl]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Alert$1, { className: 'fe-alert-success', severity: 'success', sx: { marginBottom: theme.spacing(4) } }, t('successTitle')),
        React.createElement(Grid, { container: true, justifyContent: 'center', alignItems: 'center', height: 40 },
            React.createElement(Grid, { item: true },
                React.createElement(Loader$1, null)))));
};

const resetPasswordStyler = createStyled();
const ResetPasswordPageTitle = BoxTitle;

const PasswordField$1 = () => {
    const t = useT('resetPassword');
    const [fieldProps, { error, touched }] = useField('password');
    return React.createElement(InputPassword$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, type: "password", name: "password", label: t('newPasswordInputLabel'), placeholder: t('newPasswordInputPlaceholder'), "data-test-id": "newPass-box" }));
};
const ConfirmPasswordField = () => {
    const t = useT('resetPassword');
    const [fieldProps, { error, touched }] = useField('confirmPassword');
    return React.createElement(InputPassword$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, type: "password", name: "confirmPassword", label: t('confirmPasswordInputLabel'), placeholder: t('confirmPasswordInputPlaceholder'), "data-test-id": "repeatPass-box" }));
};
const PasswordStrength = (props) => {
    const [{ value }] = useField('password');
    const t = useGlobalT();
    return React.createElement(PasswordStrengthChecker, Object.assign({ t: t, value: value, isTouched: value !== '' }, props));
};
const ResetPasswordForm = ({ token, userId }) => {
    const t = useT('resetPassword');
    const globalT = useGlobalT();
    const { error } = useForgotPasswordState();
    const { loading, passwordConfig } = usePasswordConfig();
    const { resetPassword } = useForgotPasswordActions();
    const { loadVendorPasswordConfig } = useSecurityPolicyActions();
    const { passwordPolicy } = useSecurityPolicyState();
    Owasp.setConfig(passwordPolicy.policy, globalT);
    react.exports.useEffect(() => {
        !passwordPolicy && loadVendorPasswordConfig();
    }, [passwordPolicy, loadVendorPasswordConfig]);
    const initialValues = react.exports.useMemo(() => ({ password: '', confirmPassword: '', token, userId }), [token, userId]);
    const validationSchema = react.exports.useMemo(() => validateSchema({
        password: validatePasswordUsingOWASP(t('newPasswordIsRequired')),
        confirmPassword: validateConfirmPassword(t('confirmPasswordIsRequired'), t('confirmPasswordMustMatch')),
    }), [t, passwordConfig]);
    const formikProps = {
        onSubmit: ({ password }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            resetPassword({ password, token, userId, callback });
        }),
        initialValues,
        validationSchema,
    };
    return React.createElement(React.Fragment, null,
        React.createElement(ResetPasswordPageTitle, { componentKey: "title", title: t('title') }),
        React.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return React.createElement(React.Fragment, null,
                React.createElement(PasswordField$1, null),
                React.createElement(PasswordStrength, { passwordConfig: passwordConfig, loading: loading || !passwordConfig }),
                React.createElement(ConfirmPasswordField, null),
                error && React.createElement(LoginErrorMessage, null, error),
                React.createElement(Button$1$1, { sx: { mt: 4 }, className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: "primary", loading: loading, "data-test-id": "resetPass-submit-btn" }, t('resetPasswordButton')));
        }));
};

const ResetPasswordContainer = resetPasswordStyler(Box)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const ResetPasswordPage$1 = () => {
    const { step } = useForgotPasswordState();
    const { builderMode } = useShadowDom();
    const { loadPasswordConfig, resetForgotPasswordState } = useForgotPasswordActions();
    const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    const userId = url.searchParams.get('userId') || (builderMode ? 'demo-user-id' : '');
    const token = url.searchParams.get('token') || (builderMode ? 'demo-token-id' : '');
    react.exports.useEffect(() => {
        loadPasswordConfig({ userId });
        return resetForgotPasswordState;
    }, [loadPasswordConfig, resetForgotPasswordState]);
    let components;
    if (!userId || !token) {
        components = React.createElement(ResetPasswordFailed, null);
    }
    else if (step === ForgotPasswordStep.success) {
        components = React.createElement(ResetPasswordSuccess, null);
    }
    else {
        components = React.createElement(ResetPasswordForm, { userId: userId, token: token });
    }
    return React.createElement(ResetPasswordContainer, null, components);
};

const ResetPasswordPage = wrapPage(ResetPasswordPage$1, 'resetPassword');

const signupStyler = createStyled();
const SignupPageTitle = BoxTitle;
const LoginMessageComponent = CustomComponent;

const NameField = () => {
    const t = useT('signup');
    const [fieldProps, { error, touched }] = useField('name');
    return (React.createElement(Input$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, name: 'name', label: t('nameInputLabel'), placeholder: t('nameInputPlaceholder'), "data-test-id": 'email-box' })));
};
const EmailField = () => {
    const t = useT('signup');
    const [fieldProps, { error, touched }] = useField('email');
    const { submitCount } = useFormikContext();
    return (React.createElement(Input$1, Object.assign({ autoFocus: true }, fieldProps, { onChange: fieldProps.onChange, error: !!error && touched && (fieldProps.value !== '' || submitCount > 0), errorMessage: error, name: 'email', placeholder: t('emailInputPlaceholder'), label: t('emailInputLabel'), "data-test-id": 'name-box' })));
};
const PasswordField = () => {
    const t = useT('signup');
    const [fieldProps, { error, touched }] = useField('password');
    return (React.createElement(InputPassword$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, type: 'password', name: 'password', label: t('passwordInputLabel'), placeholder: t('passwordInputPlaceholder'), "data-test-id": 'password-box' })));
};
const CompanyNameField = () => {
    const t = useT('signup');
    const [fieldProps, { error, touched }] = useField('companyName');
    return (React.createElement(Input$1, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, name: 'companyName', label: t('companyNameInputLabel'), placeholder: t('companyNameInputPlaceholder'), "data-test-id": 'companyBox' })));
};
const LoginMessage = () => {
    const t = useT('signup');
    const routes = useAuthRoutes();
    const onRedirectTo = useOnRedirectTo();
    const redirectToLogin = react.exports.useCallback(() => {
        onRedirectTo(routes.loginUrl + window.location.search);
    }, [routes.loginUrl, onRedirectTo]);
    const props = {
        goToLoginMessage: t('loginMessage'),
        goToLoginButtonText: t('loginLink'),
        goToLogin: redirectToLogin,
    };
    return React.createElement(LoginMessageComponent, Object.assign({ componentKey: 'loginMessage' }, props),
        React.createElement(LoginSignupSwitch, { variant: 'subtitle1' },
            props.goToLoginMessage,
            " ",
            React.createElement(Link, { onClick: props.goToLogin, "data-test-id": 'redirect-to-login' }, props.goToLoginButtonText)));
};
const SignUpForm = () => {
    const t = useT('signup');
    const globalT = useGlobalT();
    const { loading, error, allowNotVerifiedUsersLogin } = useSignUpState();
    const { signUpUser } = useSignUpActions();
    const { withCompanyName = true } = useShadowDom();
    const { loadVendorPasswordConfig } = useSecurityPolicyActions();
    const { invitationToken } = useVerifyInviteToken();
    const { isSSOAuth } = useAuth(({ isSSOAuth }) => ({ isSSOAuth }));
    const { passwordPolicy: { policy: passwordPolicy }, publicPolicy: { policy: publicPolicy }, } = useSecurityPolicyState();
    const recaptchaRef = React.createRef();
    react.exports.useEffect(() => {
        if (recaptchaRef.current && !loading) {
            recaptchaRef.current.execute();
        }
    }, [loading, recaptchaRef]);
    const showCompanyName = react.exports.useMemo(() => withCompanyName && !invitationToken, [withCompanyName, invitationToken]);
    Owasp.setConfig(passwordPolicy, globalT);
    react.exports.useEffect(() => {
        !passwordPolicy && loadVendorPasswordConfig();
    }, [passwordPolicy, loadVendorPasswordConfig]);
    const shouldDisplayOnlySocialLogins = react.exports.useMemo(() => !isSSOAuth && (publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy) === AuthStrategyEnum.NoLocalAuthentication, [publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy, isSSOAuth]);
    const shouldDisplayPassword = react.exports.useMemo(() => (publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy) === AuthStrategyEnum.EmailAndPassword && allowNotVerifiedUsersLogin, [publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy, allowNotVerifiedUsersLogin]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LoginMessage, null),
        React.createElement(FromWrapper, { initialValues: {
                email: '',
                name: '',
                companyName: '',
                password: shouldDisplayPassword ? '' : undefined,
                recaptchaToken: '',
            }, onSubmit: (values) => {
                if (invitationToken) {
                    values.invitationToken = invitationToken;
                }
                if (withCompanyName) {
                    signUpUser(values);
                }
                else {
                    signUpUser(Object.assign(Object.assign({}, values), { companyName: values.name }));
                }
            }, validationSchema: validateSchema({
                email: validateEmail$1(t('emailMustBeValid'), t('emailIsRequired')),
                name: validateMinLength(3, t('nameIsRequired'), t('nameMinLengthIs3')),
                companyName: showCompanyName && validateMinLength(3, t('companyNameIsRequired'), t('companyNameMinLengthIs3')),
                password: shouldDisplayPassword && validatePasswordUsingOWASP(t('passwordIsRequired')),
            }) }, ({ isValid }) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(EmailField, null),
                React.createElement(NameField, null),
                showCompanyName && React.createElement(CompanyNameField, null),
                shouldDisplayPassword && React.createElement(PasswordField, null),
                error && React.createElement(LoginErrorMessage, null, error),
                React.createElement(Box, { height: '1px', mb: 4 }),
                React.createElement(Button$1$1, { className: 'fe-primary-btn', disabled: !isValid, type: 'submit', fullWidth: true, color: 'primary', loading: loading, "data-test-id": "signupSubmit-btn" }, t('signupButtonText')),
                React.createElement(ReCaptcha, { recaptchaRef: recaptchaRef, action: 'sign_up' })));
        }),
        React.createElement(SocialLoginsSignUp, { dividerText: t('signUpWithSocialLogin'), withSocialDivider: !shouldDisplayOnlySocialLogins })));
};

const SignUpSuccessContainer = styled$3(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '.MuiTypography-root': {
        marginBottom: '2rem',
    },
});
const SignUpSuccessMessage = styled$3(Typography)(({ theme }) => ({
    color: theme.palette.grey[700],
}));
const SignUpSuccessHeader = styled$3(Typography)({
    marginBottom: '1.75rem',
});
const SignUpSuccess = () => {
    const t = useT('signup');
    const { shouldActivate, onRedirectTo, routes } = useAuth(({ signUpState, routes, onRedirectTo }) => (Object.assign({ routes, onRedirectTo }, signUpState)));
    const { resetSignUpStateSoft } = useAuthActions();
    const message = react.exports.useMemo(() => {
        if (shouldActivate) {
            return t('successActivateMessage');
        }
        return t('successGoToLoginButton');
    }, [t, shouldActivate]);
    react.exports.useEffect(() => {
        if (!shouldActivate) {
            onRedirectTo(routes.signUpSuccessUrl || routes.authenticatedUrl);
        }
        return resetSignUpStateSoft;
    }, [shouldActivate, routes, resetSignUpStateSoft, onRedirectTo]);
    if (!shouldActivate) {
        return null;
    }
    return (React.createElement(SignUpSuccessContainer, null,
        React.createElement(SignUpSuccessHeader, { align: 'center', variant: 'h3' }, t('successTitle')),
        React.createElement(SignUpSuccessMessage, { variant: 'subtitle2', align: 'center' }, message)));
};

var SignUpStage;
(function (SignUpStage) {
    SignUpStage["SignUp"] = "SignUp";
    SignUpStage["SignUpSuccess"] = "SignUpSuccess";
})(SignUpStage || (SignUpStage = {}));
const SignupContainer = signupStyler(Box)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const SignUpPage$1 = () => {
    const t = useT('signup');
    const signUpState = useSignUpState();
    const routes = useAuthRoutes();
    const { inviteTokenError } = useLoginState(({ inviteTokenError }) => ({ inviteTokenError }));
    const onRedirectTo = useOnRedirectTo();
    useAuth(({ isSSOAuth }) => ({ isSSOAuth }));
    useSecurityPolicyState();
    const redirectToLogin = react.exports.useCallback(() => {
        onRedirectTo(routes.loginUrl);
    }, [onRedirectTo, routes.loginUrl]);
    if (!signUpState.firstLoad && !signUpState.allowSignUps) {
        redirectToLogin();
        return null;
    }
    const { action, components } = react.exports.useMemo(() => {
        let components = null;
        let action = null;
        if (inviteTokenError) {
            action = AuthActions.SignUpFailed;
            // components = <TenantInvitationFailed variant='signup' t={t}/>;
        }
        else {
            switch (signUpState.stage) {
                case SignUpStage.SignUpSuccess:
                    action = AuthActions.SignUpSuccess;
                    components = React.createElement(SignUpSuccess, null);
                    break;
                case SignUpStage.SignUp:
                default:
                    action = AuthActions.SignUp;
                    components = React.createElement(SignUpForm, null);
                    // {!shouldDisplayOnlySocialLogins && <SignUpForm/>}
                    // <SocialLoginsSignUp dividerText='Or Sign Up With' withSocialDivider={!shouldDisplayOnlySocialLogins}/>
                    break;
            }
        }
        return ({ action, components, t });
    }, [signUpState.stage, inviteTokenError]);
    return React.createElement(SignupContainer, null,
        React.createElement(SignupPageTitle, { componentKey: 'title', title: t('title') }),
        components);
};

const SignUpPage = wrapPage(SignUpPage$1, 'signup');

const OidcLoginSuccess = () => {
    const onRedirectTo = useOnRedirectTo();
    const ssoState = useSSOState();
    const routes = useAuthRoutes();
    const { isLoading, isAuthenticated } = useAuth(({ isLoading, isAuthenticated }) => ({ isLoading, isAuthenticated }));
    const t = useT('login');
    const theme = useTheme();
    const { setSSOState, oidcPostlogin } = useSSOActions();
    const loadingMode = react.exports.useMemo(() => !ssoState.error && ssoState.loading, [ssoState.error, ssoState.loading]);
    react.exports.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const state = params.get('state');
        const code = params.get('code');
        const error = t('failedOicdLoginTitle');
        if (!state || !code) {
            setSSOState({ error });
            return;
        }
        try {
            const encodedState = atob(state);
            const encodeStateTenantIdMatch = encodedState.match(/tenantId=([a-zA-Z0-9-]{0,};)/);
            if (!encodeStateTenantIdMatch) {
                setSSOState({ error });
            }
        }
        catch (e) {
            setSSOState({ error });
            return;
        }
        const { origin, pathname } = window.location;
        const redirectUri = `${origin}${pathname}`;
        oidcPostlogin({ code, state, redirectUri });
        // eslint-disable-next-line
    }, []);
    react.exports.useEffect(() => {
        if (!isLoading && isAuthenticated) {
            let authenticatedUrl = routes.authenticatedUrl;
            const afterAuthRedirect = window.localStorage.getItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            if (afterAuthRedirect) {
                authenticatedUrl = afterAuthRedirect;
            }
            window.localStorage.removeItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            onRedirectTo(authenticatedUrl);
        }
    }, [onRedirectTo, isLoading, isAuthenticated, routes]);
    return loadingMode ? React.createElement(PageLoader, null) : (React.createElement(AuthPage, null,
        React.createElement(Alert$1, { severity: 'error', sx: { marginBottom: theme.spacing(4) } }, ssoState.error),
        React.createElement(Button$1$1, { fullWidth: true, onClick: () => {
                onRedirectTo(routes.loginUrl);
            } }, t('failedOicdBackToLogin'))));
};

const LogoutPage$1 = () => {
    const { loginUrl } = useAuthRoutes();
    const { logout } = useLoginActions();
    const { basename = '', urlStrategy } = useShadowDom();
    const calculatedBasename = basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '';
    react.exports.useEffect(() => {
        setTimeout(() => {
            logout(() => {
                const path = calculatedBasename + loginUrl;
                if (urlStrategy === 'path') {
                    window.location.href = path;
                }
                else {
                    window.location.href = `${window.location.pathname}#${path}`;
                }
            });
        }, 500);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logout]);
    return React.createElement(PageLoader, null);
};

const LogoutPage = wrapPageWithoutBox(LogoutPage$1, 'login');

const MagicLinkCallbackContainer = styled$3(Box)({
    marginBottom: '1.5rem',
});
const MagicLinkCallbackMessage = styled$3(Typography)(({ theme }) => ({
    color: theme.palette.grey[700],
}));
const MagicLinkCallbackHeader = styled$3(Typography)({
    marginBottom: '1.75rem',
});
const MagicLinkCallbackPage$1 = () => {
    const t = useT('login');
    const { invitationToken } = useVerifyInviteToken();
    const { passwordlessPostLogin, resetLoginState } = useLoginActions();
    const { captchaPolicy } = useSecurityPolicyState();
    const { error } = useLoginState();
    const { isLoading, isAuthenticated } = useAuth(({ isLoading, isAuthenticated }) => ({ isLoading, isAuthenticated }));
    const recaptcha = useRecaptcha({ action: 'magic_link_postlogin' });
    const onRedirectTo = useOnRedirectTo();
    const routes = useAuthRoutes();
    const token = react.exports.useMemo(() => new URLSearchParams(window.location.search).get('token'), []);
    react.exports.useEffect(() => {
        if (!isLoading && isAuthenticated) {
            let authenticatedUrl = routes.authenticatedUrl;
            const afterAuthRedirect = window.localStorage.getItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            if (afterAuthRedirect) {
                authenticatedUrl = afterAuthRedirect;
            }
            window.localStorage.removeItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            onRedirectTo(authenticatedUrl);
        }
    }, [onRedirectTo, isLoading, isAuthenticated, routes]);
    react.exports.useEffect(() => {
        var _a;
        if (!captchaPolicy.loading && token && (!((_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled) || (recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token))) {
            passwordlessPostLogin({ token, invitationToken, recaptchaToken: recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token, type: AuthStrategyEnum.MagicLink });
        }
    }, [token, recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token, captchaPolicy, passwordlessPostLogin]);
    const backToLogin = react.exports.useCallback(() => {
        onRedirectTo(routes.loginUrl);
        resetLoginState();
    }, [onRedirectTo, routes.loginUrl, resetLoginState]);
    if (!token || error) {
        return (React.createElement(BoxElement$1, { themeOptionKey: 'login' },
            React.createElement(MagicLinkCallbackContainer, null,
                React.createElement(MagicLinkCallbackHeader, { align: 'center', variant: 'h3' }, t(`invalidMagicLinkTitle`)),
                React.createElement(MagicLinkCallbackMessage, { variant: 'subtitle2', align: 'center', sx: { marginBottom: 4 } }, !token ? t('invalidMagicLinkText') : error),
                React.createElement(Button$1$1, { sx: { mt: 4 }, "data-test-id": 'back-to-login-btn', className: 'fe-primary-btn', fullWidth: true, color: 'primary', onClick: backToLogin }, t(`backToLogin`)))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(PageLoader, null), recaptcha === null || recaptcha === void 0 ? void 0 :
        recaptcha.component));
};

const MagicLinkCallbackPage = wrapPageWithoutBox(MagicLinkCallbackPage$1, 'login');

const HostedLoginPage = () => {
    const { handleHostedLoginCallback } = useLoginActions();
    const params = useQueryParams('code', 'state', 'nonce');
    react.exports.useEffect(() => handleHostedLoginCallback(params), [handleHostedLoginCallback, params]);
    return React.createElement(PageLoader, null);
};

const getUri = (urlStrategy) => {
    if (urlStrategy === 'path') {
        return (window !== null && window !== void 0 ? window : document).location.pathname;
    }
    else {
        return ((window !== null && window !== void 0 ? window : document).location.hash || '#').substring(1);
    }
};
const Routes = ({ staticRoute }) => {
    const { isLoading } = useAuth(({ isLoading }) => ({ isLoading }));
    const { basename = '', urlStrategy } = useShadowDom();
    const routes = useAuthRoutes();
    const uriRef = react.exports.useRef(getUri(urlStrategy));
    const [uri, setUri] = react.exports.useState(getUri(urlStrategy));
    const onUriChanged = react.exports.useCallback(() => {
        const uri = getUri(urlStrategy);
        if (uriRef.current !== uri) {
            uriRef.current = uri;
            setUri(uri);
        }
    }, [setUri, urlStrategy]);
    react.exports.useEffect(() => {
        document.addEventListener('frontegg_onRedirectTo_fired', onUriChanged);
        window.addEventListener('popstate', onUriChanged);
        window.addEventListener('hashchange', onUriChanged, false);
        setInterval(onUriChanged, 50);
        return () => {
            window.removeEventListener('popstate', onUriChanged);
            window.removeEventListener('hashchange', onUriChanged);
        };
    }, [onUriChanged]);
    if (isLoading) {
        return React.createElement(PageLoader, null);
    }
    const calculatedBasename = basename ? (basename.endsWith('/') ? basename.substring(0, basename.length - 1) : basename) : '';
    switch (staticRoute !== null && staticRoute !== void 0 ? staticRoute : uri) {
        case calculatedBasename + routes.loginUrl:
            return React.createElement(LoginPage, null);
        case calculatedBasename + routes.logoutUrl:
            return React.createElement(LogoutPage, null);
        case calculatedBasename + routes.activateUrl:
            return React.createElement(ActivateAccountPage, null);
        case calculatedBasename + routes.acceptInvitationUrl:
            return React.createElement(AcceptInvitationPage, null);
        case calculatedBasename + routes.forgetPasswordUrl:
            return React.createElement(ForgotPasswordPage, null);
        case calculatedBasename + routes.resetPasswordUrl:
            return React.createElement(ResetPasswordPage, null);
        case calculatedBasename + routes.socialLoginCallbackUrl:
            return React.createElement(SocialLoginsSuccess, null);
        case calculatedBasename + routes.signUpUrl:
            return React.createElement(SignUpPage, null);
        case calculatedBasename + routes.oidcRedirectUrl:
            return React.createElement(OidcLoginSuccess, null);
        case calculatedBasename + routes.magicLinkCallbackUrl:
            return React.createElement(MagicLinkCallbackPage, null);
        case calculatedBasename + routes.hostedLoginRedirectUrl:
            return React.createElement(HostedLoginPage, null);
    }
    return null;
};

const defaultTheme = 'modern';
const LoginBox = ({ injector, options }) => {
    var _a, _b;
    ContextHolder.setOnRedirectTo(options.onRedirectTo);
    return React.createElement(ShadowDomContext.Provider, { value: Object.assign(Object.assign({ iframeRendering: false, injector }, options), { themeOptions: enhanceTheme(defaultTheme, (_a = options.metadata) !== null && _a !== void 0 ? _a : {}, (_b = options.themeOptions) !== null && _b !== void 0 ? _b : {}, options), slotsContainer: injector.loginBoxContainer, rootEl: injector.loginBoxEl, renderByRoute: true }) },
        React.createElement(App, null,
            React.createElement(Routes, null)));
};
const LoginBoxPage = ({ injector, options, staticRoute, setThemeSetter, setStaticRouteSetter }) => {
    var _a;
    const [themeOptions, setThemeOptions] = react.exports.useState(enhanceTheme(defaultTheme, {}, (_a = options.themeOptions) !== null && _a !== void 0 ? _a : {}));
    const [route, setRoute] = react.exports.useState(staticRoute);
    // @ts-ignore
    setThemeSetter === null || setThemeSetter === void 0 ? void 0 : setThemeSetter((theme) => setThemeOptions(enhanceTheme(defaultTheme, {}, theme !== null && theme !== void 0 ? theme : {})));
    setStaticRouteSetter === null || setStaticRouteSetter === void 0 ? void 0 : setStaticRouteSetter(setRoute);
    return React.createElement(ShadowDomContext.Provider, { value: Object.assign(Object.assign({ injector, iframeRendering: false }, options), { themeOptions, slotsContainer: injector.loginBoxContainer, rootEl: injector.loginBoxEl, renderByRoute: true }) },
        React.createElement(App, null,
            React.createElement(Routes, { staticRoute: route })));
};

export { LoginBox, LoginBoxPage, LoginBox as default, defaultTheme };
